import React, { useRef, useState } from 'react';
// import _ from 'lodash';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import dayjs from 'dayjs';
import { abs, add, subtract, divide, multiply } from 'mathjs';
import { useAuthUser } from 'react-auth-kit';
// import {QRCodeComponent} from './QRCode.jsx';

// GRAPHQL QUERY
import { SaveUserQRCode } from './users_graphql.js';
import { 
    GetWorkoutPrograms,
    SaveWorkoutProgram,
    SaveWorkoutProgramSets
} from './workout_programs_graphql.js';

// DOCS: https://www.apollographql.com/docs/react/get-started/
// Import everything needed to use the `useQuery` hook
import { useLazyQuery, useMutation } from '@apollo/client';
import { QRCodeComponent } from './qr_code_component.js';
// import { handleError } from '@apollo/client/link/http/parseAndCheckHttpResponse';
import { WorkoutsGraphComponent} from './workouts_graph_component.js';
import { WorkoutsExportComponent} from './workouts_export_component.js';
import { useDownloadExcel } from 'react-export-table-to-excel';

export function WorkoutsCardComponent(props) {
    console.log("Workout props: ", props);
    const tableRef = useRef(null);

    const [Workouts, setWorkouts] = useState([ ...props.usersQRCodes ]);
    const [SelectedWorkout, setSelectedWorkout] = useState({ user_QR_code_ID: 0 });
    const [BaseState, setBaseState] = useState({ 
        loading: false,
        show_calculator: false,
        show_qr_reader: false 
    });
    // const qrCodeReader = new QRReader();
    // const videoElement = document.getElementById('video');

    const [save_qr_code] = useMutation(SaveUserQRCode);

    // Handle QR Code Result
    async function handleQRCode(code) {
        console.log({code})
        setBaseState({ ...BaseState, show_qr_reader: false })
        let QR_code = {};

        // Logic for parsing the QR Code
                    let SplitArray = code.split(',');
                    console.log({SplitArray})
                    let exercise = '';
                    let final_key = '';
                    let is_weight = false;
                    let L_torque = 0;
                    let R_torque = 0;
                    let torque_total = 0;
                    let last_rep_value = '';
                    let set = 1;
                    let set_side_length = '';
                    let set_torque = 0;
                    let side = '';
                    let side_full_word = '';
                    let side_torque_exercise = '';

                    SplitArray.forEach((split, index) => {
                        if(index === 0) {
                            QR_code.exercise_date = dayjs().format();
                        } else if(index === 1) {
                            QR_code.start_time = split;
                        } else if(index === 2) {
                            QR_code.end_time = split;
                        } else {

                            // Reset the set counter once it gets to 6
                            if(set === 6) set = 1;

                            // Is this index a rep or a weight value
                            is_weight = index % 2 === 0;

                            // 10 indexes per side, per exercise: L1_rep, L1_weight,..., R1_rep, R1_weight...
                            // 3-12 L_supra, 13-22 R_supra, 23-32 L_infra, 33-42 R_infra, 43-52 L_teres, 53-62 R_teres, 63-72 L_subscap, 73-82 R_subscap, 83-92 L_surfer, 93-102 R_surfer
                            if ( index > 2 && index < 23 ) {
                                exercise = 'supra';
                            } else if ( index > 22 && index < 43 ) {
                                exercise = 'infra';
                            } else if ( index > 42 && index < 63 ) {
                                exercise = 'teres';
                            } else if ( index > 62 && index < 83 ) {
                                exercise = 'subscap';
                            } else if ( index > 82 && index < 103 ) {
                                exercise = 'surfer';
                            }

                            // Determine left or right side
                            side = ( index > 2 && index < 13 ) || ( index > 22 && index < 33 ) || ( index > 42 && index < 53 ) ||  ( index > 62 && index < 73 ) || ( index > 82 && index < 93 ) ? `L` : `R`;
                            side_full_word = side === 'L' ? 'left' : 'right';

                            // If this was somehow a negative number, remove the negative sign 
                            split = split.charAt(0) === '-' ? split. replace(/^./, "") : split;

                            // Turn string weights into numbers with tenths decimal place, reps into integers
                            split = is_weight ? parseFloat(split).toFixed(1) : parseInt(split);

                            // If is_weight, we already have this side/set's rep count, use that from the last time through this loop, along with this index's split, to calculate the torque of this set
                            if(is_weight && props.SelectedUser[`arm_length_${side_full_word}`] > 0 && props.SelectedUser[`forearm_length_${side_full_word}`] > 0 ) {

                                // Value of last index / last time through this loop, which is the rep count of this current index's weight value
                                last_rep_value = QR_code[`${side}${set}_rep_${exercise}`];

                                // Create the string for this index's key to go into QR_code object
                                side_torque_exercise = `${side}_torque_${exercise}`;

                                // Calculate the torque for each exercise by side
                                if( exercise === 'supra' ) {

                                    // Get user's arm length for this side, to use in calculation
                                    set_side_length = props.SelectedUser[`arm_length_${side_full_word}`];

                                    // This set's torque calculation
                                    set_torque = (set_side_length/12)*0.7*last_rep_value*split;

                                } else {
                                
                                    // Get user's forearm length for this side, to use in calculation
                                    set_side_length = props.SelectedUser[`forearm_length_${side_full_word}`];

                                    // This set's torque calculation
                                    set_torque = (set_side_length/12)*last_rep_value*split;
                                
                                }

                                // The first option needs to be fixed and parsed, somehow the js addition goes wild with decimals without this
                                set_torque = parseFloat(set_torque.toFixed(3));
                                QR_code[`${side}_torque_${exercise}`] = set > 1 ? parseFloat((QR_code[`${side}_torque_${exercise}`]+set_torque).toFixed(3)) : set_torque;

                                // If this is set 5 of the side, turn the torque into a string so it can save as a decimal into the db
                                if( set === 5 ) {
                                    QR_code[`${side}_torque_${exercise}`] = QR_code[`${side}_torque_${exercise}`].toString();
                                }

                                // Continue adding torques to the L, R, and Total torques
                                if ( side === 'L' ) {
                                    L_torque = L_torque !== 0 ? parseFloat((L_torque+set_torque).toFixed(3)) : set_torque;
                                } else if ( side === 'R' ) {
                                    R_torque = R_torque !== 0 ? parseFloat((R_torque+set_torque).toFixed(3)) : set_torque;
                                }
                                torque_total = torque_total !== 0 ? parseFloat((torque_total+set_torque).toFixed(3)) : set_torque;
                            }

                            // Add rep / weight and the exercise to get final_key - Odd index = rep, even index = weight
                            final_key = is_weight ? `${side}${set}_weight_${exercise}` : `${side}${set}_rep_${exercise}`


                            // final_key = ( index > 2 && index < 8 ) || ( index > 12 && index < 18 ) || ( index > 22 && index < 28 ) || ( index > 32 && index < 38 ) || ( index > 42 && index < 48 ) || ( index > 52 && index < 58 ) || 
                            //             ( index > 62 && index < 68 )|| ( index > 72 && index < 78 ) || ( index > 82 && index < 88 ) || ( index > 92 && index < 98 ) ? `${side_set}_rep_${exercise}` : `${side_set}_weight_${exercise}`;
                            // final_key = ( index > 2 && index < 8 ) || ( index > 7 && index < 13 ) || ( index > 12 && index < 18 ) || ( index > 17 && index < 23 ) || ( index > 22 && index < 28 ) || ( index > 27 && index < 33 ) || 
                            //             ( index > 32 && index < 38 ) || ( index > 37 && index < 43 ) || ( index > 42 && index < 48 ) || ( index > 47 && index < 53 ) || ( index > 52 && index < 58 ) || ( index > 57 && index < 63 ) || 
                            //             ( index > 62 && index < 68 ) || ( index > 67 && index < 73 ) || ( index > 72 && index < 78 ) || ( index > 77 && index < 83 ) || ( index > 82 && index < 88 ) || ( index > 87 && index < 93 ) || 
                            //             ( index > 92 && index < 98 ) || ( index > 97 && index < 103 ) ? `${side_set}_rep_${exercise}` : `${side_set}_weight_${exercise}`;


                            // Create QR_code key and value
                            QR_code[final_key] = split;

                            // Up the set counter by 1 every 2 times through this loop
                            set = is_weight ? set+1 : set;
                        }
                    });

                    // Update torque side totals, total. Have to convert the number to a string to save into decimal type for some reason
                    QR_code.L_torque = L_torque.toString();
                    QR_code.R_torque = R_torque.toString();
                    QR_code.torque_total = torque_total.toString();
console.log({QR_code})

                    // Set exercise list to loading, and save the QR Code
                    // setBaseState({
                    //     ...BaseState,
                    //     loading: true
                    // });

        // Parse string values that are IDs to be integers, saving stringified numbers to the database throws an error.
        // let MakeIntegers = [ 'user_ID', 'archiver_ID', 'creator_ID', 'customer_ID', 'height_feet', 'player_number', 'user_type_ID', 'updater_ID'];
        

        // MakeIntegers.forEach((mi) => SaveData[mi] = parseInt(SaveData[mi]));

        // // Remove save mesasge and button text from User object for saving
        // SaveData = _.omit(SaveData, ['date_last_benchmark','date_last_workout','save_button_text','save_message']);

        const result = await save_qr_code({ variables: { input: { ...QR_code, QR_code: code, QR_code_parsed: 1, user_ID: parseInt(props.SelectedUser.user_ID), user_QR_code_ID: 0 } }});
console.log({result})

        if ( result.data && result.data.usersQRCodeSave && result.data.usersQRCodeSave.user_QR_code_ID > 0 ) {
            console.log("UPDATE WORKOUTS")
            // Add this QR Code to the Workouts
            let TempWorkouts = [...Workouts];
            TempWorkouts.unshift(result.data.usersQRCodeSave);
            console.log(TempWorkouts)
            setWorkouts([...TempWorkouts]);
        }
    }

    function handleCloseGraph() {
        props.setAction('');
        setTimeout(() => props.playerRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' }), 200);
    }


    // NuShoulder Workout Entries card
    // let supra = '15, 11.5, 15, 11.5, 0, 0, 0, 0, 0, 0, 15, 11.5, 15, 11.5, 0, 0, 0, 0, 0, 0,';
    // let sub = '15, 11, 15, 11, 0, 0, 0, 0, 0, 0, 15, 11, 15, 11, 0, 0, 0, 0, 0, 0,';
    // let infra = '15, 10.5, 15, 10.5, 0, 0, 0, 0, 0, 0, 15, 10.5, 15, 10.5, 0, 0, 0, 0, 0, 0,';
    // let teres = '15, 10.5, 15, 10.5, 0, 0, 0, 0, 0, 0, 15, 10.5, 15, 10.5, 0, 0, 0, 0, 0, 0,';
    // let house = '15, 10, 15, 10, 0, 0, 0, 0, 0, 0, 15, 9.5, 15, 9.5, 0, 0, 0, 0, 0, 0';
    // let test = `08-01-2024, 8:28 AM,    09:52:02, ${supra} ${sub} ${infra} ${teres} ${house}`;
    // let test = "04-04-2025, 2:17 PM,  08:49:59, 1, 1.5, 0, 2.4, 0, 0, 0, 0, 0, 0, 2, 1.6, 0, 0, 0, 0, 0, 0, 0, 0, 3, 1.7, 0, 2.4, 0, 0, 0, 0, 0, 0, 4, 1.8, 0, 0, 0, 0, 0, 0, 0, 0, 5, 1.9, 0, 2.4, 0, 0, 0, 0, 0, 0, 6, 2.0, 0, 0, 0, 0, 0, 0, 0, 0, 7, 2.1, 0, 2.4, 0, 0, 0, 0, 0, 0, 9, 2.2, 0, 0, 0, 0, 0, 0, 0, 0, 10, 2.3, 0, 2.4, 0, 0, 0, 0, 0, 0, 11, 2.4, 0, 0, 0, 0, 0, 0, 0, 0"
    
    let filename = props.SelectedUser.user_ID > 0 && Workouts.length > 0 ? `${props.SelectedUser.first_name}_${props.SelectedUser.last_name}_all_workouts_${dayjs(Workouts[0].exercise_date).format('MM_DD_YYYY')}` : `all_workouts`
    const { onDownload } = useDownloadExcel({
        currentTableRef: tableRef.current,
        filename: `${filename}`,
        sheet: 'Workouts'
    });

    function TorqueDiffCalc(index) {
        if ( Workouts.length-1 !== index ) {
            let current = Workouts[index].torque_total;

            let previous = Workouts[index+1].torque_total;

            if ( current !== '0.000' && previous !== '0.000') {
                let calc = multiply(100,divide((subtract(current, previous)), previous ));
                if ( calc > 0 ) {
                    return <span style={{ color: 'green'}}>{calc.toFixed(2)} %</span>;
                } else if ( calc < 0 ) {
                    return <span style={{color: 'red'}}>{calc.toFixed(2)} %</span>;
                } else {
                    return <span>{calc.toFixed(2)} %</span>;
                }
            } else {
                return (
                    <span> -- </span>
                )
            }

        } else {
            return (
                <span> -- </span>
            )
        }
    }

    function handleOpenWorkoutCalculator() {
    
        setBaseState({ ...BaseState, show_calculator: true }); 
        
        // if ( Workouts.length > 0 ) {
        //     setSelectedWorkout({ ...Workouts[0], index: 0 })
        // }

    }

    return (
        <div className="card h-100">
            <div className="card-header border h4 border-secondary">
                <div className="clearfix">
                    <span className={`float-start mt-1 h4 ${!props.card_open && 'text-muted'}`} onClick={() => props.setCardOpenWorkouts(!props.card_open)}>
                        <span style={{width: 40+'px'}}>{(props.card_open && <FontAwesomeIcon icon="fa-chevron-down" className="me-2" />) || <FontAwesomeIcon icon="fa-chevron-right" className="me-2" />}</span>
                        NuShoulder Workout Entries
                    </span>

                    {/* Only show button when displaying SelectedWorkout */}
                    {
                        parseInt(SelectedWorkout.user_QR_code_ID) > 0 && 
                        <span className="float-end">
                            <button className="btn btn-sm fw-bold col-auto border-secondary border-3 text-secondary float-end" onClick={() => setSelectedWorkout({ user_QR_code_ID: 0})}>
                                <FontAwesomeIcon icon="fa-arrow-left" className="me-2" />Back to Entries
                            </button>
                        </span>
                    }
                    {
                        parseInt(SelectedWorkout.user_QR_code_ID) === 0 && 
                        <span className="float-end">
                            {
                                BaseState.show_qr_reader === false && BaseState.show_calculator === false &&
                                (
                                    (
                                        props.Action === 'workout_graph' &&
                                        <button className="btn btn-sm fw-bolder text-secondary border border-secondary border-3 float-end" onClick={() => handleCloseGraph()}><FontAwesomeIcon icon="fa-times" className="me-2" />Close Graph</button>
                                    ) ||
                                    <>
                                        <button className="btn btn-sm fw-bold col-auto border-primary border-3 text-primary float-end" disabled={parseInt(props.SelectedUser.user_ID) === 0} onClick={() => setBaseState({ ...BaseState, show_qr_reader: true })}>
                                            <FontAwesomeIcon icon="fa-qrcode" className="me-2" />Scan QR Code
                                        </button>
                                        {/* <button className="btn btn-sm fw-bold col-auto border-primary border-3 text-primary float-end" disabled={parseInt(props.SelectedUser.user_ID) === 0} onClick={() => handleQRCode(test)}>
                                            <FontAwesomeIcon icon="fa-qrcode" className="me-2" />Scan QR Code
                                        </button> */}
                                        
                                        {/* Graph Icon */}
                                        <button className="btn btn-sm fw-bolder text-primary border border-primary border-3 ms-2 me-2 float-end" disabled={parseInt(props.SelectedUser.user_ID) === 0} onClick={() => props.setAction('workout_graph')}><FontAwesomeIcon icon="fa-chart-line" className="" /></button>

                                        {/* Excel Export Icon */}
                                        <button onClick={onDownload} className="btn btn-sm fw-bold col-auto border-primary border-3 text-primary float-end mb-2" disabled={parseInt(props.SelectedUser.user_ID) === 0}>
                                            <FontAwesomeIcon icon="fa-file-excel" className="" />
                                        </button>
                                        <WorkoutsExportComponent 
                                            Workouts={Workouts} 
                                            SelectedUser={props.SelectedUser} 
                                            tableRef={tableRef} 
                                            export_type={'all_workouts'} 
                                        />

                                        {/* Calculate Torques and Next Workouts */}
                                        <button className="btn btn-sm fw-bolder text-primary border border-primary border-3 ms-2 me-2 float-end" onClick={() => handleOpenWorkoutCalculator()} disabled={parseInt(props.SelectedUser.user_ID) === 0}><FontAwesomeIcon icon="fa-calculator" className="" /></button>
                                    </>
                                )
                            }
                            {
                                BaseState.show_qr_reader &&
                                <button className="btn btn-sm fw-bold col-auto border-secondary border-3 text-secondary float-end" disabled={parseInt(props.SelectedUser.user_ID) === 0} onClick={() => setBaseState({ ...BaseState, show_qr_reader: false })}>
                                    <FontAwesomeIcon icon="fa-times" className="me-2" />Close Scanner
                                </button>
                            }                            
                            {
                                BaseState.show_calculator &&
                                <button className="btn btn-sm fw-bold col-auto border-secondary border-3 text-secondary float-end" disabled={parseInt(props.SelectedUser.user_ID) === 0} onClick={() => setBaseState({ ...BaseState, show_calculator: false })}>
                                    <FontAwesomeIcon icon="fa-times" className="me-2" />Close Workout Calculator
                                </button>
                            }                            
                        </span>
                    }

                    
                </div>
                {
                    BaseState.show_qr_reader && 
                    <div className="clearfix">
                        <QRCodeComponent handleQRCode={(result) => handleQRCode(result)} />
                    </div>
                }
                {
                    BaseState.show_calculator && 
                    <>
                        <div className="clearfix mt-3 mb-2">
                            <TorqueCalculatorComponent Workouts={Workouts} SelectedUser={props.SelectedUser} />
                        </div>
                        <div className="clearfix mt-3 mb-2">
                            <WorkoutWizardComponent Workouts={Workouts} SelectedUser={props.SelectedUser} />
                        </div>
                    </>
                }
            </div>

            {/* Conditional show the body content based on the chevron for props.card_open */}
            {
                props.card_open &&
                <div className="card-body border border-secondary border-top-0">
                    {/* Body - show workout entries or SelectedWorkout */}
                    {
                        Workouts.length === 0 &&
                        (
                            (parseInt(props.SelectedUser.user_ID) === 0 && <div className="alert alert-info">Save new player details before adding workout entries.</div>)
                            || (parseInt(props.SelectedUser.user_ID) > 0 && <div className="alert alert-info">No Workout Entries Recorded</div>)
                        )
                    }
                    {
                        Workouts.length > 0 &&
                        SelectedWorkout.user_QR_code_ID === 0 &&
                        <table className="table table-striped table-hover">
                            <thead className="h6 ">
                                <tr className="row">
                                    <th className="col-5">Total Work Performed (ft-lbs)</th>
                                    <th className="col-3">Workout Date</th>
                                    <th className="col-4">Weekday</th>
                                </tr>
                            </thead>
                            <tbody>
                                {Workouts.map((QR, index) => {
                                    return (
                                        <tr className="row" key={QR.user_QR_code_ID} onClick={() => setSelectedWorkout({ ...QR, index: index })}>
                                            <td className="col-5 clearfix">
                                                <span className="float-start">{QR.torque_total}</span>
                                                <span className="float-end pe-5">{TorqueDiffCalc(index)}</span>
                                            </td>
                                            <td className="col-3">
                                                {dayjs(QR.exercise_date).format('M-D-YY')}
                                            </td>
                                            <td className="col-4">
                                                {dayjs(QR.exercise_date).format('dddd')}
                                            </td>
                                        </tr>
                                    )
                                })}
                            </tbody>
                        </table>
                    }
                    {
                        parseInt(SelectedWorkout.user_QR_code_ID) > 0 && 
                        <div className="mt-0">
                            <WorkoutDetailsComponent SelectedWorkout={SelectedWorkout} SelectedUser={props.SelectedUser} Workouts={Workouts} />
                        </div>
                    }

                </div>

            }

            {/* Footer - display next scheduled workout */}
            <div className="card-footer text-center border border-secondary border-top-0">
                <span className="float-start"><span className="text-muted">Next Scheduled Workout:</span> {(Workouts.length === 0 && <span className="text-danger">Not Scheduled</span>) || 'Wednesday 2-28-24' }</span>
            </div>
        </div>

    )
}

// SelectedWorkout display - exercise details for each workout, reps x weight with torque totals
export function WorkoutDetailsComponent(props) {
    console.log({props})
    const tableRef = useRef(null);

    const { SelectedUser, SelectedWorkout: QR, Workouts } = props;

    const called_from = props.called_from ? props.called_from : '';

    const workouts = ['supra', 'infra', 'teres', 'subscap', 'surfer'];
    const capitalized = ['Supra', 'Infra', 'Teres Minor', 'Subscap', 'House Combo'];
    const reps = [1,2,3,4,5];

    const { onDownload } = useDownloadExcel({
        currentTableRef: tableRef.current,
        filename: `${SelectedUser.first_name}_${SelectedUser.last_name}_workout_${dayjs(QR.exercise_date).format('MM_DD_YYYY')}`,
        sheet: `${dayjs(QR.exercise_date).format('MM-DD-YYYY')} Workout`
    });

    function TorqueDiffCalc(side, e, index) {
        if ( Workouts.length-1 !== index ) {
            let current = Workouts[index][`${side}_torque_${e}`];

            let previous = Workouts[index+1][`${side}_torque_${e}`];

            if ( current !== '0.000' && previous !== '0.000') {
                let calc = multiply(100,divide((subtract(current, previous)), previous ));
                if ( calc > 0 ) {
                    return <span style={{ color: 'green'}}>{calc.toFixed(2)} %</span>;
                } else if ( calc < 0 ) {
                    return <span style={{color: 'red'}}>{calc.toFixed(2)} %</span>;
                } else {
                    return <span>{calc.toFixed(2)} %</span>;
                }
            } else {
                return (
                    <span> -- </span>
                )
            }

        } else {
            return (
                <span> -- </span>
            )
        }
    }

    return (
        <div className="clearfix">
            {
                called_from !== 'wizard' &&
                <>
                    <div className="clearfix">
                        <button onClick={onDownload} className="btn btn-sm fw-bold col-auto border-primary border-3 text-primary float-end mb-2">
                            <FontAwesomeIcon icon="fa-file-excel" className="me-2" />Export Workout Data To Excel
                        </button>
                    </div>

                    <WorkoutsExportComponent 
                        Workouts={Workouts} 
                        Workout={QR} 
                        SelectedUser={props.SelectedUser} 
                        tableRef={tableRef} 
                        workouts={workouts} 
                        capitalized={capitalized} 
                        reps={reps} 
                        export_type={'single_workout'} 
                    />
                </>
            }

            <div className="">
                {/* Top Information Container*/}
                <div className="clearfix">
                    <div className="float-start"><span className="text-muted">Workout Date: </span><br />{dayjs(QR.exercise_date).format('dddd M-D-YY')}</div>
                    <div className="float-end">
                        <div className="text-muted">Workout's Total Work Performed</div>
                        <div className=""><span className="float-end">{QR.torque_total} ft-lbs</span></div>
                    </div>
                </div>

                {/* Individual Workout cards */}
                {
                    workouts.map((w, index) => {
                        return (
                            <div className="card mt-4" key={index}>
                                <div className="card-header">
                                    <div className="float-start h5 mb-0">{capitalized[index]}</div>
                                    <div className="float-end">
                                        <span className="text-muted">Total Work Performed: </span>
                                        <span className="fw-bolder">{parseFloat(add(QR[`L_torque_${w}`], QR[`L_torque_${w}`]).toFixed(3))} ft-lbs</span>
                                    </div>
                                </div>
                                <div className="card-body py-2">
                                    <div className="clearfix text-muted mb-1">
                                        <span className="float-start border-bottom border-2">Left Arm</span>
                                        <span className="float-end border-bottom border-2">Right Arm</span>
                                    </div>
                                    <div className="clearfix">
                                        <div className="float-start">
                                            {/* Left Side Reps */}
                                            {
                                                reps.map((r) => {
                                                    // Only show rep line if there were actual reps performed
                                                    if ( QR[`L${r}_rep_${w}`] !== 0 ) {
                                                        return (
                                                            <div className="clearfix" key={r}>
                                                                {QR[`L${r}_weight_${w}`]} lbs x {QR[`L${r}_rep_${w}`]}
                                                                {/* <span><FontAwesomeIcon icon="fa-pencil" className="ms-2 text-primary" /></span> */}
                                                            </div>
                                                        )
                                                    } else {
                                                        return null;
                                                    }
                                                })
                                            }
                                        </div>

                                        {/* Right Side Reps */}
                                        <div className="float-end">
                                            {
                                                reps.map((r) => {
                                                    // Only show rep line if there were actual reps performed
                                                    if ( QR[`R${r}_rep_${w}`] !== 0 ) {
                                                        return (
                                                            <div className="clearfix" key={r}>
                                                                {QR[`R${r}_weight_${w}`]} lbs x {QR[`R${r}_rep_${w}`]}
                                                                {/* <span><FontAwesomeIcon icon="fa-pencil" className="ms-2 text-primary" /></span> */}
                                                            </div>
                                                        )
                                                    } else {
                                                        return null;
                                                    }
                                                })
                                            }
                                        </div>
                                    </div>
                                </div>
                                <div className="card-footer fw-bolder">
                                    {QR[`L_torque_${w}`] !== '0.0' && <div className="float-start">{parseFloat(QR[`L_torque_${w}`])} ft-lbs<br />{TorqueDiffCalc('L', w, QR.index)}</div>}
                                    {QR[`R_torque_${w}`] !== '0.0' && <div className="float-end">{parseFloat(QR[`R_torque_${w}`])} ft-lbs<br /><span className="float-end">{TorqueDiffCalc('R', w, QR.index)}</span></div>}
                                </div>
                            </div>
                        )
                    })
                }            </div>

        </div>
    )
}

// Torque Calculator display - 
export function TorqueCalculatorComponent(props) {
    console.log({props})

    const { SelectedUser, Workouts } = props;
    const has_measurements = SelectedUser.arm_length_left !== null && SelectedUser.arm_length_left !== null && SelectedUser.arm_length_left !== null && SelectedUser.arm_length_left !== null;

    const workouts = ['supra', 'infra', 'teres', 'subscap', 'surfer'];
    const capitalized = ['Supra', 'Infra', 'Teres Minor', 'Subscap', 'House Combo'];
    const reps = [1,2,3,4,5];

    const [Arm, setArm] = useState('right');
    const [CalculatedWorkouts, setCalculatedWorkouts] = useState([]);
    const [Exercise, setExercise] = useState('Supra');
    const [Reps, setReps] = useState(1);
    const [Sets, setSets] = useState(1);
    const [Weight, setWeight] = useState(10);

    // Update the state for any changing input
    function changeInputValue(name, value) {
        // For inputs that must be integers, do not allow non numeric characters, and parseInt on the value
        if ( name === 'Reps' ) {
            if(value !== '') {
                value = parseInt(value)
                // Prevent 'NaN' 
                if( isNaN(value) ) {
                    value = 0;
                }
            } else {
                // This is to avoid attempting to save "" as an INT
                value = 0;
            }
            setReps(value)
        } 
        else if ( name === 'Weight' ) {
            if(value !== '') {
                // Strips non-numeric characters, leaves decimal
                value = value.replace(/[^\d.-]/g, '');
                // Handle decimal length restrictions
                if (value.includes('.')) {
                    let decimal_length = value.split('.')[1].length;
                    if ( decimal_length !== 0 ) {
                        value = parseFloat(value).toFixed(1)
                    }
                } else if ( value !== '' ) {
                    value = parseInt(value);
                }
            }
            setWeight(value)
        } 
    }

    // Handler function for calculating torque based off inputs
    function handleTorqueCalculation() {
        let set_side_length;
        let set_torque;
        let total_torque;

        // Calculate the torque for each exercise by side
        if( Exercise === 'Supra' ) {

            // Get user's arm length for this side, to use in calculation
            set_side_length = SelectedUser[`arm_length_${Arm}`];

            // This set's torque calculation
            set_torque = (set_side_length/12)*0.7*Reps*Weight;

            total_torque = set_torque*Sets;

        } else {
        
            // Get user's forearm length for this side, to use in calculation
            set_side_length = SelectedUser[`forearm_length_${Arm}`];

            // This set's torque calculation
            set_torque = (set_side_length/12)*Reps*Weight;

            total_torque = set_torque*Sets;
        
        }

        // The first option needs to be fixed and parsed, somehow the js addition goes wild with decimals without this
        set_torque = parseFloat(set_torque.toFixed(3));    

        let NewWorkout = {
            Arm,
            Exercise,
            Reps,
            Sets,
            Weight,
            set_torque: parseFloat(set_torque.toFixed(3)),
            total_torque: parseFloat(total_torque.toFixed(3))            
        }
        let TempWorkouts = [...CalculatedWorkouts];
        TempWorkouts.push(NewWorkout);
        setCalculatedWorkouts(TempWorkouts)

    }

    // Determine if the Calculate Torque button should be disabled
    // function handleCalculateTorqueDisabled() {

    //     if ( Reps === 0 ) {
    //     Reps === 0 || Weight === '' || Weight === 0 || Weight === 0.0 || (Weight.includes('.') && Weight.split('.')[1].length === 0)
    //     }
    // }

    // Delete a row from the Torque Calculator list of records
    function handleDeleteTorqueCalculatorRecord(index) {
        let TempCalculatedWorkouts = [...CalculatedWorkouts];
        TempCalculatedWorkouts.splice(index,1);
        setCalculatedWorkouts(TempCalculatedWorkouts);
    }

    return (
        <div className="clearfix">
            <div className="card h-100">
                <div className="card-header h5 border border-secondary">
                    <div className="clearfix">
                        <span className="float-start mt-1">Exercise Set's Work Performed Calculator</span>
                    </div>
                </div>
                <div className="card-body border border-secondary border-top-0">

                    <div className="row clearfix justify-content-center">
                        <div className="form-floating col-3">
                            <select 
                                className="form-select" 
                                disabled={!has_measurements}
                                id="sets"
                                onChange={(event) => setSets(event.target.value)}
                                placeholder="Sets"
                                value={SelectedUser.sets}
                            >
                                <option value={1}>1</option>
                                <option value={2}>2</option>
                                <option value={3}>3</option>
                                <option value={4}>4</option>
                                <option value={5}>5</option>
                            </select> 
                            <label className="text-muted ms-2 h6" htmlFor="sets">Sets</label>
                        </div>
                        <div className="form-floating col-3">
                            <input className="form-control float" disabled={!has_measurements} id="reps" value={Reps} onChange={(event) => changeInputValue('Reps', event.target.value)} /> 
                            <label className="text-muted ms-2 h6" htmlFor="reps">Reps</label>
                        </div>
                        <div className="form-floating col-3">
                            <input className="form-control float" disabled={!has_measurements} id="weight" value={Weight} onChange={(event) => changeInputValue('Weight', event.target.value)} /> 
                            <label className="text-muted ms-2 h6" htmlFor="weight">Weight (lbs - 0.1)</label>
                        </div>
                    </div>

                    <div className="row clearfix mt-3 justify-content-center">
                        {/* ARM */}
                        <div className="col-auto">
                            <div className="btn-group btn-group-sm" role="group">
                                <button className={`btn btn-outline-secondary ${(Arm === 'left' && 'btn-secondary text-white border border-dark') || 'text-dark'}`} onClick={() => setArm('left')}>
                                    Left
                                </button>
                                <button className={`btn btn-outline-secondary ${(Arm === 'right' && 'btn-secondary text-white border border-dark') || 'text-dark'}`} onClick={() => setArm('right')}>
                                    Right
                                </button>
                            </div>                            
                        </div>

                        {/* EXERCISE */}
                        <div className="col-auto">
                            <div className="btn-group btn-group-sm" role="group">
                                <button className={`btn btn-outline-secondary ${(Exercise === 'Supra' && 'btn-secondary text-white border border-dark') || 'text-dark'}`} onClick={() => setExercise('Supra')}>
                                    Supra
                                </button>
                                <button className={`btn btn-outline-secondary ${(Exercise === 'Infra' && 'btn-secondary text-white border border-dark') || 'text-dark'}`} onClick={() => setExercise('Infra')}>
                                    Infra
                                </button>
                                <button className={`btn btn-outline-secondary ${(Exercise === 'Teres Minor' && 'btn-secondary text-white border border-dark') || 'text-dark'}`} onClick={() => setExercise('Teres Minor')}>
                                    Teres Minor
                                </button>
                                <button className={`btn btn-outline-secondary ${(Exercise === 'Subscap' && 'btn-secondary text-white border border-dark') || 'text-dark'}`} onClick={() => setExercise('Subscap')}>
                                    Subscap
                                </button>
                                <button className={`btn btn-outline-secondary ${(Exercise === 'House Combo' && 'btn-secondary text-white border border-dark') || 'text-dark'}`} onClick={() => setExercise('House Combo')}>
                                    House Combo
                                </button>
                            </div>                            
                        </div>
                    </div>
                    <div className="row clearfix mt-3 justify-content-center">
                        {/* CALCULATE BUTTON */}
                        <div className="col-auto">
                            <button className="btn btn-sm fw-bolder text-primary border border-primary border-3" disabled={Reps === 0 || Weight === '' || Weight === 0 || Weight === 0.0 } onClick={() => handleTorqueCalculation()}>
                                <FontAwesomeIcon icon="fa-calculator" className="me-2" />Calculate Work Performed
                            </button>
                        </div>
                    </div>
                </div>

                {/* Footer - display calculated workouts (these are really individual exercise's sets) */}
                {
                    CalculatedWorkouts.length > 0 &&
                    <div className="card-footer border border-secondary border-top-0 mx-0 px-0 pt-0">
                        <table className="table table-striped table-hover h6 mx-0">
                            <thead className="" style={{fontSize: '75%'}}>
                                <tr className="row mx-0">
                                    <th className="col-4">Exercise</th>
                                    <th className="text-center col-1">Reps</th>
                                    <th className="text-center col-2">Weight</th>
                                    <th className="text-center col-2">Set's Work</th>
                                    <th className="text-center col-1">Sets</th>
                                    <th className="text-center col-2">Total Work</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    CalculatedWorkouts.map((CW, index) => {
                                        return (
                                            <tr className="row mx-0" key={index}>
                                                <td className="col-4">
                                                    <span className="text-danger" onClick={() => handleDeleteTorqueCalculatorRecord(index)}><FontAwesomeIcon icon="fa-trash-alt" className="me-2" /></span>
                                                    {(CW.Arm === 'right' && 'R - ') || 'L - '}
                                                    {CW.Exercise}
                                                </td>
                                                <td className="text-center col-1">{CW.Reps}</td>
                                                <td className="text-center col-2">{CW.Weight}</td>
                                                <td className="text-center col-2">{CW.set_torque.toFixed(1)}</td>
                                                <td className="text-center col-1">{CW.Sets}</td>
                                                <td className="text-center col-2">{CW.total_torque.toFixed(1)}</td>
                                            </tr>
                                        )
                                    })
                                }
                            </tbody>
                        </table>
                    </div>
                }
            </div>
        </div>
    )
}

// Workout Wizard -Create a workout plan
export function WorkoutWizardComponent(props) {
    console.log({props})

    const auth = useAuthUser();

    const { SelectedUser, Workouts } = props;
    const LastWorkout = Workouts.length > 0 ? { ...Workouts[0], index: 0 } : {index: -1};
    const has_measurements = SelectedUser.arm_length_left !== '0.00' && SelectedUser.arm_length_left !== '0.00' && SelectedUser.arm_length_left !== '0.00' && SelectedUser.arm_length_left !== '0.00';

    const workouts = ['supra', 'infra', 'teres', 'subscap', 'house'];
    const capitalized = ['Supra', 'Infra', 'Teres Minor', 'Subscap', 'House Combo'];
    const reps = [1,2,3,4,5];

    const DefaultBaseState = {
        Arm: ['right', 'left'],
        Exercises: ['supra'],
        increase_torque_by: '',
        increase_torque_by_program: '',
        increase_torque_by_percentage: '',
        increase_torque_by_percentage_program: '',
        increase_weight_by: '',
        increase_weight_by_program: '',
        number_of_workouts: 3,
        program: 'new',
        // program: props.Workouts.length > 0 ? 'last' : 'new',
        reps: 15,
        reps_max: 0,
        reps_min: 0,
        reset_workout_program_button_text: 'Clear Workout Program',
        save_workout_program_button_text: 'Save',
        save_workout_program_message: '',
        sets: 5,
        torque_increase_type: 'exercise',
        weight: 12,
        weight_max: 0,
        weight_min: 0,
        workout_generated: false, // 0 = stable - show "Generate Workout Program", 1 = program generate - show "Workout Program Generated"
        workouts_count: 0,
        workouts_per_increase: 1
    };
    const [BaseState, setBaseState] = useState(DefaultBaseState);

    const DefaultCalculatedWorkouts = [
        { exercise: 'supra', Workouts: [] },
        { exercise: 'infra', Workouts: [] },
        { exercise: 'teres', Workouts: [] },
        { exercise: 'subscap', Workouts: [] },
        { exercise: 'house', Workouts: [] }
    ];
    const [CalculatedWorkouts, setCalculatedWorkouts] = useState([ ...DefaultCalculatedWorkouts ]);
    const [LastWorkoutCalculation, setLastWorkoutCalculation] = useState([ ...DefaultCalculatedWorkouts ]);
    
    const DefaultWorkoutProgram = {
        workout_program_ID: 0,
        active: 0,
        archiver_ID: 0,
        creator_ID: 0,
        customer_ID: 0,
        date_archived: null,
        date_created: null,
        date_updated: null,
        workout_program_name: '',
        updater_ID: 0,
        user_ID: 0

    }

    
    const [SelectedCreatedProgram, setSelectedCreatedProgram] = useState([]);
    const [SelectedWorkoutProgram, setSelectedWorkoutProgram] = useState({...DefaultWorkoutProgram});
    const [WorkoutPrograms, setWorkoutPrograms] = useState([]);
    const [WorkoutTorques, setWorkoutTorques] = useState([]);
    const [Hovering, setHovering] = useState({Workout: 0})

    // MUTATIONS 
    const [save_workout_program] = useMutation(SaveWorkoutProgram);
    const [save_workout_program_sets] = useMutation(SaveWorkoutProgramSets);
    const [get_workout_programs] = useLazyQuery(GetWorkoutPrograms, { fetchPolicy: 'network-only'});


    // Update the state for any changing input
    function changeInputValue(name, value) {
        // For inputs that must be integers, do not allow non numeric characters, and parseInt on the value
        if ( name === 'reps' || name === 'number_of_workouts' || name === 'increase_torque_by' ) {
            if(value !== '') {
                value = parseInt(value)
                // Prevent 'NaN' 
                if( isNaN(value) ) {
                    value = 0;
                }
            } else {
                // This is to avoid attempting to save "" as an INT
                value = 0;
            }
        } 
        else if ( name === 'weight' || name === 'increase_torque_by_percentage' || name === 'increase_weight_by' || name === 'increase_weight_by_program' ) {
            if(value !== '') {
                // Strips non-numeric characters, leaves decimal
                value = value.replace(/[^\d.-]/g, '');
                // Handle decimal length restrictions
                if (value.includes('.')) {
                    let decimal_length = value.split('.')[1].length;
                    if ( decimal_length !== 0 ) {
                        value = parseFloat(value).toFixed(1)
                    }
                } else if ( value !== '' ) {
                    value = parseInt(value);
                }
            }
        } 

        let NewState = { [name]: value };
        // If this changing input is one of the Torque Increases, and blank out the other
        if ( name === 'increase_torque_by') {
            NewState = { ...NewState, increase_torque_by_percentage: '', increase_weight_by: ''};
        } else if ( name === 'increase_torque_by_percentage') {
            NewState = { ...NewState, increase_torque_by: '', increase_weight_by: ''};
        } else if ( name === 'increase_weight_by') {
            NewState = { ...NewState, increase_torque_by: '', increase_torque_by_percentage: ''};
        } else if ( name === 'increase_torque_by_program') {
            NewState = { ...NewState, increase_torque_by_percentage_program: '', increase_weight_by_program: ''};
        } else if ( name === 'increase_torque_by_percentage_program') {
            NewState = { ...NewState, increase_torque_by_program: '', increase_weight_by_program: ''};
        } else if ( name === 'increase_weight_by_program') {
            NewState = { ...NewState, increase_torque_by_program: '', increase_torque_by_percentage_program: ''};
        }

        setBaseState({ ...BaseState, ...NewState, workout_generated: false});
    };

    // Click handler for selecting exercises to graph. If the exercise is already in the array, remove it, otherwise add it.
    function handleSetExercises(exercise) {

        let index = BaseState.Exercises.findIndex((E) => E === exercise );
        let TempExercises = [...BaseState.Exercises];

        if ( exercise === 'all' ) {
            TempExercises = ['supra','infra','teres','subscap','house'];
        } else if ( exercise === 'clear' ) {
            TempExercises = [];
        } else if ( index > -1 ) {
            TempExercises.splice(index, 1);
        } else {
            TempExercises.push(exercise);
        }
        setBaseState({ ...BaseState, Exercises: TempExercises, workout_generated: false });
        // targetRef.current?.scrollIntoView({ behavior: 'smooth', block: 'end' });
    };

    // Click handler for selecting arm sides to graph. If the side is already in the array, remove it, otherwise add it.
    function handleSetArm(arm) {
        let index = BaseState.Arm.findIndex((A) => A === arm );
        let TempArm = [...BaseState.Arm];
        if ( index > -1 ) {
            TempArm.splice(index, 1);
        } else {
            TempArm.push(arm);
        }
        setBaseState({ ...BaseState, Arm: TempArm, workout_generated: false });
        // targetRef.current?.scrollIntoView({ behavior: 'smooth', block: 'end' })
    };

    // Handler function for actually generating the new Workout Program's workouts based on inputs
    function handleGenerateWorkouts() {
        let L_arm = SelectedUser.arm_length_left;
        let R_arm = SelectedUser.arm_length_right;
        let L_forearm = SelectedUser.forearm_length_left;
        let R_forearm = SelectedUser.forearm_length_right;
        let L_torque = 0;
        let L_torque_total = 0;
        let R_torque = 0;
        let R_torque_total = 0;
        let total_torque;
        let { Arm, Exercises, number_of_workouts, reps, sets, weight } = BaseState;
        let Program = { arm: Arm, exercises: Exercises, reps, sets, weight, total_torque: 0, Workouts: CalculatedWorkouts }
        let left = Arm.findIndex((A) => A === 'left') > -1;
        let right = Arm.findIndex((A) => A === 'right') > -1;
        // Calculate the arm component of torque calculations for reuseability
        let left_arm_supra = L_arm > 0 ? multiply(0.7, divide(L_arm, 12)) : 0;
        let right_arm_supra = R_arm > 0 ? multiply(0.7, divide(R_arm, 12)) : 0;
        let left_forearm_other = L_forearm > 0 ? divide(L_forearm, 12) : 0;
        let right_forearm_other = R_forearm > 0 ? divide(R_forearm, 12) : 0;

        // GENERATE THE FIRST WORKOUT OF THE NEW PROGRAM, THEN WE CAN BUILD THE NEXT WORKOUTS BASED ON ITS TORQUES
        if ( BaseState.program !== 'last') {
            console.log("DO NOT ENTER IF LAST PROGRAM")
            let i;
            for ( i = 0; i < 1; i++ ) {
                let TempWorkout = [];
                // For each new Workout, reset the overall Workout specific torque calculations
                L_torque_total = 0;
                R_torque_total = 0;
                total_torque = 0;

                // Map through each selected Exercise
                Exercises.map((E) => {

                    // Array of each Exercise's specific sets for this workout
                    let ExerciseLSets = [];
                    let ExerciseRSets = [];
                    L_torque = 0;
                    R_torque = 0;

                    // Calculate the torque for each exercise by side
                    if( E === 'supra' ) {

                        // This set's torque calculations
                        if ( left ) { L_torque = left_arm_supra*reps*weight; }
                        if ( right ) { R_torque = right_arm_supra*reps*weight; }
                        // if ( left ) { L_torque = (L_arm/12)*0.7*reps*weight; }
                        // if ( right ) { R_torque = (R_arm/12)*0.7*reps*weight; }

                        // Create a Workout object for each set
                        let j;
                        for ( j = 1; j <= sets; j++ ) {
                            let LSet = {};
                            let RSet = {};
                            if ( left ) {
                                LSet.L_reps = reps;
                                LSet.L_weight = weight;
                                LSet.L_torque = L_torque.toFixed(3);
                                // Push this set's details (reps/weight) to the array of this Exercise's Sets
                                ExerciseLSets.push(LSet)
                            }
                            if ( right ) {
                                RSet.R_reps = reps;
                                RSet.R_weight = weight;
                                RSet.R_torque = R_torque.toFixed(3);
                                // Push this set's details (reps/weight) to the array of this Exercise's Sets
                                ExerciseRSets.push(RSet)
                            }
                        }
                    } else {

                        // This set's torque calculations
                        if ( left ) { L_torque = left_forearm_other*reps*weight; }
                        if ( right ) { R_torque = right_forearm_other*reps*weight; }

                        // Create a Workout object for each set
                        let j;
                        for ( j = 1; j <= sets; j++ ) {
                            let LSet = {};
                            let RSet = {};
                            if ( left ) {
                                LSet.L_reps = reps;
                                LSet.L_weight = weight;
                                LSet.L_torque = L_torque.toFixed(3);
                                // Push this set's details (reps/weight) to the array of this Exercise's Sets
                                ExerciseLSets.push(LSet)
                            }
                            if ( right ) {
                                RSet.R_reps = reps;
                                RSet.R_weight = weight;
                                RSet.R_torque = R_torque.toFixed(3);
                                // Push this set's details (reps/weight) to the array of this Exercise's Sets
                                ExerciseRSets.push(RSet)
                            }
                        }                
                    }

                    L_torque_total = L_torque*sets;
                    R_torque_total = R_torque*sets;
                    total_torque = L_torque_total + R_torque_total;


                    // Push this Exercise's Sets to the TempWorkout array for this specific Workout
                    TempWorkout.push({ exercise: E, LSets: ExerciseLSets, RSets: ExerciseRSets, LTorque: L_torque_total.toFixed(3), RTorque: R_torque_total.toFixed(3), Torque: total_torque.toFixed(3) });

                });

                // Add these new Workouts to the existing array of Workouts
                Program.Workouts = Program.Workouts.map((W) => {
                
                    let TempW = { ...W };
                    // Get this Workout's Exercise from the TempWorkout array that was just generated
                    let matching_exercise_index = TempWorkout.findIndex((TW) => TW.exercise === W.exercise );
                    // Add the newly generated Workouts to the existing Program's Workouts for this exercise, if there were any Workouts for this exercise generated just now.
                    if ( matching_exercise_index > -1 ) {
                        // If only a single arm was added right now, check if there are existing workouts for this exercise that already have the other arm created, then add this current arm's new sets to that workout.
                        if ( Arm.length === 1 && TempW.Workouts.length > i) {
                            // Handles a case of adding 3 right workouts, then 2 left workouts, then another 2 left workouts. This keeps adding to left as the 3rd and 4th workouts for the last 2 added.
                            let workouts_with_left_sets = 0;
                            let workouts_with_right_sets = 0;
                            TempW.Workouts.forEach((w) => {
                                if ( w.LSets.length > 0 ) workouts_with_left_sets = add(workouts_with_left_sets,1);
                                if ( w.RSets.length > 0 ) workouts_with_right_sets = add(workouts_with_right_sets,1);
                            });
                            // Check if there are Workouts for the other arm, but not this arm. If so, update this Workout number's Exercise's Workouts array for this current arm.
                            if ( Arm[0] === 'left' && TempW.Workouts[i].RSets.length > 0 && workouts_with_left_sets < workouts_with_right_sets ) {
                                TempW.Workouts[workouts_with_left_sets].LSets = TempWorkout[matching_exercise_index].LSets;
                            }
                            else if ( Arm[0] === 'right' && TempW.Workouts[i].LSets.length > 0 && workouts_with_left_sets > workouts_with_right_sets ) {
                                TempW.Workouts[workouts_with_right_sets].RSets = TempWorkout[matching_exercise_index].RSets;
                            }
                            else {
                                TempW.Workouts.push({LSets: TempWorkout[matching_exercise_index].LSets, RSets: TempWorkout[matching_exercise_index].RSets, LTorque: TempWorkout[matching_exercise_index].LTorque, RTorque: TempWorkout[matching_exercise_index].RTorque, Torque: TempWorkout[matching_exercise_index].Torque })
                            }
                        } else {
                            TempW.Workouts.push({LSets: TempWorkout[matching_exercise_index].LSets, RSets: TempWorkout[matching_exercise_index].RSets, LTorque: TempWorkout[matching_exercise_index].LTorque, RTorque: TempWorkout[matching_exercise_index].RTorque, Torque: TempWorkout[matching_exercise_index].Torque})
                        }
                    }
                    return TempW;
                });
            }
        }

        // GENERATE REMAINING WORKOUTS FOR THE NEW PROGRAM, AFTER THE FIRST HAS BEEN GENERATED ABOVE
        // Now that we have the torque totals for each workout for the first workout, do the math to figure out what the next workout's torque totals will be
        if ( number_of_workouts > 1 || BaseState.program === 'last') {
            let LSetsArray = [...Array(sets).keys()];
            let RSetsArray = [...Array(sets).keys()];

            // Map over the Exercises, and set their final torques
            BaseState.Exercises.forEach((E) => {
                let NewProgram = [];
                let TempLastWorkout = [];

                // Get Last Work, either generated or from their actual workouts records, to get the Torques we must build off of for these new workouts we will generate below.
                // FUNCTION - WE CAN PULL THIS OUT INTO ITS OWN FUNCTION
                if ( BaseState.program !== 'last') {
                    // NewProgram = Workouts for a specific exercise. Then get the last workout's data for torque calculations, since they may have already had workouts created for this exercise.
                    NewProgram = Program.Workouts.filter((W) => W.exercise === E)[0].Workouts;
                    TempLastWorkout = NewProgram[NewProgram.length-1];
                } else if ( BaseState.program === 'last' ) {
                    if ( BaseState.workouts_count === 0) {
                        // If this is the first time generating the Workout Program from the Build From Last, then utilize the CalculatedWorkouts / Program.Workouts array, as if it were the first workout generated for a New Program.
                        TempLastWorkout = LastWorkoutCalculation.filter((W) => W.exercise === E)[0].Workouts[0];
                    } else {
                        // If we already generated some workouts for this Program based on the last work, we need to check for each exercise if the Program has new workouts in it now. 
                        // If so, generate these next workouts based off the last workout that we generated. Otherwise, utilize the data from their actual last workout
                        let TempFindProgramWorkouts = Program.Workouts.filter((W) => W.exercise === E)[0].Workouts;
                        if ( TempFindProgramWorkouts.length > 0 ) {
                            TempLastWorkout = TempFindProgramWorkouts[TempFindProgramWorkouts.length-1];
                        } else {
                            TempLastWorkout = LastWorkoutCalculation.filter((W) => W.exercise === E)[0].Workouts[0]
                        }
                    }
                    LSetsArray = [...Array(TempLastWorkout.LSets.length).keys()];
                    RSetsArray = [...Array(TempLastWorkout.RSets.length).keys()];
                }

                let WorkoutTemplate = { LSets: [], RSets: [], LTorque: 0, RTorque: 0, Torque: 0 };

                // Create arrays for the remaining workouts to add to the program. For Build From Last, we are not generating a first workout above, so generate the actual specified number of workouts.
                let WorkoutsArray = BaseState.program === 'last' ? [...Array(number_of_workouts).keys()] : [...Array(number_of_workouts-1).keys()];
                let LeftTorqueTemp = TempLastWorkout.LTorque;
                let RightTorqueTemp = TempLastWorkout.RTorque;
                let increase_torque_by_left = '';
                let increase_torque_by_right = '';
                let increase_torque_by_percentage = '';

                // For the remaining number of workouts, create new arrays for these with the updated torques.
                // We want to get a variable that can be used for increasing each workout's torque by, regardless of which option is selected 
                // On the per exercise increases, just add on to the last workout's torque
                if ( BaseState.increase_torque_by !== '' || BaseState.increase_torque_by_percentage !== '' ) {
                    // If Left and Right, then divide the increase by 2
                    let increase_torque_by = BaseState.increase_torque_by !== '' && left && right ? divide(BaseState.increase_torque_by, 2) : BaseState.increase_torque_by;
                    increase_torque_by_left = increase_torque_by;
                    increase_torque_by_right = increase_torque_by;
                    increase_torque_by_percentage = BaseState.increase_torque_by_percentage;
                    // increase_torque_by_percentage = BaseState.increase_torque_by_percentage !== '' && left && right ? divide(BaseState.increase_torque_by_percentage, 2) : BaseState.increase_torque_by_percentage;
                }
                // On the per exercise increases, just add on to the last workout's torque
                else if ( BaseState.increase_torque_by_program !== '' || BaseState.increase_torque_by_percentage_program !== '' ) {
                    // If Left and Right, then divide the increase by 2
                    let increase_torque_by_program = BaseState.increase_torque_by_program !== '' && left && right ? divide(BaseState.increase_torque_by_program, 2) : BaseState.increase_torque_by_program;
                    let increase_torque_by_percentage_program = BaseState.increase_torque_by_percentage_program;
                    // let increase_torque_by_percentage_program = BaseState.increase_torque_by_percentage_program !== '' && left && right ? divide(BaseState.increase_torque_by_percentage_program, 2) : BaseState.increase_torque_by_percentage_program;
                    // Divide these across the number of workouts. For simplicity, treat the percentage increase as a linear torque increase. Later, we can create a non-linear solution.
                    let increase_torque_by = increase_torque_by_program !== '' ? divide(increase_torque_by_program, subtract(number_of_workouts,1) ) : increase_torque_by_program;
                    // let increase_torque_by_percentage = '';
                    increase_torque_by_left = increase_torque_by;
                    increase_torque_by_right = increase_torque_by;
                    // If we want to increase the entire program by a percentage, take the first workout of the program's values, increase them by this percentage, and determine a torque increase value per workout for each side.
                    if ( increase_torque_by_percentage_program !== '' ) {
                        let LeftTorqueTempFinal = multiply(parseFloat(LeftTorqueTemp), add(1, multiply(increase_torque_by_percentage_program, 0.01)));
                        let RightTorqueTempFinal = multiply(parseFloat(RightTorqueTemp), add(1, multiply(increase_torque_by_percentage_program, 0.01)));
                        increase_torque_by_left = divide( subtract(LeftTorqueTempFinal,parseFloat(LeftTorqueTemp)), subtract(number_of_workouts,1) );
                        increase_torque_by_right = divide( subtract(RightTorqueTempFinal,parseFloat(RightTorqueTemp)), subtract(number_of_workouts,1) );
                    }
                }
                // On the weight increases, simply add the requested weight to each workout, and calculate the new torque for this weight, as this will be the only variable that changes
                else if ( BaseState.increase_weight_by !== '' || BaseState.increase_weight_by_program !== '' ) {
                        // if ( left ) { L_torque = left_arm_supra*reps*weight; }
                        // if ( right ) { R_torque = right_arm_supra*reps*weight; }
                        // if ( left ) { L_torque = left_forearm_other*reps*weight; }
                        // if ( right ) { R_torque = right_forearm_other*reps*weight; }                
                }

                // let left_arm_supra = L_arm > 0 ? multiply(0.7, divide(L_arm, 12)) : 0;
                // let right_arm_supra = R_arm > 0 ? multiply(0.7, divide(R_arm, 12)) : 0;
                // let left_forearm_other = L_forearm > 0 ? divide(L_forearm, 12) : 0;
                // let right_forearm_other = R_forearm > 0 ? divide(R_forearm, 12) : 0;
                // console.log({left_arm_supra})
                // console.log({right_arm_supra})
                // console.log({left_forearm_other})
                // console.log({right_forearm_other})
                // Map for each remaining Workout, and push it to the Program.Workouts for this Exercise
                // console.log({increase_torque_by_left})
                // console.log({LeftTorqueTemp})
                // console.log({increase_torque_by_percentage})

                let temp_weight = weight;

                // Generate the requested number of workouts
                WorkoutsArray.forEach((W, workouts_array_index) => {
                    let ThisWorkout = { ...WorkoutTemplate };
                    // For Workout/Program increases by torque, we need to do calculations to determine the new combination of reps/weight that will get closest to the desired new increase in torque.
                    if ( BaseState.increase_torque_by !== '' || BaseState.increase_torque_by_percentage !== '' || BaseState.increase_torque_by_program !== '' || BaseState.increase_torque_by_percentage_program !== '' ) {
                        if ( left ) {
                            LeftTorqueTemp = increase_torque_by_left !== '' ? add(LeftTorqueTemp, increase_torque_by_left) : multiply(LeftTorqueTemp, add(1, multiply(increase_torque_by_percentage, 0.01)));
                            let LeftSetTorqueTemp = LSetsArray.length > 0 ? divide(LeftTorqueTemp, LSetsArray.length).toFixed(3) : 0;
                            // Given the torque for each set, calculate the reps and weight needed to get this torque
                            let L_reps_weight_goal = E === 'supra' ? divide(LeftSetTorqueTemp, left_arm_supra) : divide(LeftSetTorqueTemp, left_forearm_other);
                            // console.log({L_reps_weight_goal})
                            let temp_reps = reps;
                            temp_weight = weight;
                            let exact_weight = divide(L_reps_weight_goal, temp_reps); console.log({exact_weight});
                            let exact_weight_fixed = exact_weight.toFixed(1); console.log({exact_weight_fixed});
                            if ( exact_weight_fixed > 19.9 ) {
                                temp_reps = add(temp_reps, 1);
                                exact_weight = divide(L_reps_weight_goal, temp_reps); console.log({exact_weight});
                                exact_weight_fixed = exact_weight.toFixed(1); console.log({exact_weight_fixed});
                            }
                            let secondary_weight_fixed = subtract(exact_weight,exact_weight_fixed) > 0 ? add(exact_weight_fixed, 0.1).toFixed(1) : subtract(exact_weight_fixed, 0.1).toFixed(1); console.log({secondary_weight_fixed});
                            // With the lower and upper weight within 0.1 lbs of the same reps, determine which is closer to the goal
                            temp_weight = abs( subtract(L_reps_weight_goal, multiply(exact_weight_fixed,temp_reps) )) > abs( subtract(L_reps_weight_goal, multiply(secondary_weight_fixed,temp_reps) )) ? secondary_weight_fixed: exact_weight_fixed;
                            // Utilize this new weight and reps to calculate the true torque of this workout
                            LeftSetTorqueTemp = E === 'supra' ? multiply(temp_reps, temp_weight, left_arm_supra).toFixed(3) : multiply(temp_reps, temp_weight, left_forearm_other).toFixed(3);
                            let LSetsTemp = LSetsArray.map((S) => { return { L_reps: temp_reps, L_weight: temp_weight, L_torque: LeftSetTorqueTemp } } );
                            // Ultilize the new Set Torque to get the total Torque for this workout
                            LeftTorqueTemp = LSetsArray.length > 0 ? multiply(LeftSetTorqueTemp, LSetsArray.length).toFixed(3) : 0;
                            ThisWorkout = { ...ThisWorkout, LTorque: LeftTorqueTemp, LSets: LSetsTemp };
                        }
                        if ( right ) {
                            RightTorqueTemp = increase_torque_by_right !== '' ? add(RightTorqueTemp, increase_torque_by_right) : multiply(RightTorqueTemp, add(1, multiply(increase_torque_by_percentage, 0.01)));
                            let RightSetTorqueTemp = RSetsArray.length > 0 ? divide(RightTorqueTemp, RSetsArray.length).toFixed(3) : 0;
                            // Given the torque for each set, calculate the reps and weight needed to get this torque
                            let R_reps_weight_goal = E === 'supra' ? divide(RightSetTorqueTemp, right_arm_supra) : divide(RightSetTorqueTemp, right_forearm_other);
                            // console.log({R_reps_weight_goal})
                            let temp_reps = reps;
                            temp_weight = weight;
                            let exact_weight = divide(R_reps_weight_goal, temp_reps); console.log({exact_weight});
                            let exact_weight_fixed = exact_weight.toFixed(1); console.log({exact_weight_fixed});
                            if ( exact_weight_fixed > 19.9 ) {
                                temp_reps = add(temp_reps, 1);
                                exact_weight = divide(R_reps_weight_goal, temp_reps); console.log({exact_weight});
                                exact_weight_fixed = exact_weight.toFixed(1); console.log({exact_weight_fixed});
                            }
                            let secondary_weight_fixed = subtract(exact_weight,exact_weight_fixed) > 0 ? add(exact_weight_fixed, 0.1).toFixed(1) : subtract(exact_weight_fixed, 0.1).toFixed(1); console.log({secondary_weight_fixed});
                            // With the lower and upper weight within 0.1 lbs of the same reps, determine which is closer to the goal
                            temp_weight = abs( subtract(R_reps_weight_goal, multiply(exact_weight_fixed,temp_reps) )) > abs( subtract(R_reps_weight_goal, multiply(secondary_weight_fixed,temp_reps) )) ? secondary_weight_fixed: exact_weight_fixed;
                            // Utilize this new weight and reps to calculate the true torque of this workout
                            RightSetTorqueTemp = E === 'supra' ? multiply(temp_reps, temp_weight, right_arm_supra).toFixed(3) : multiply(temp_reps, temp_weight, right_forearm_other).toFixed(3);
                            // console.log("multiply(temp_reps, temp_weight, right_arm_supra): ", multiply(temp_reps, temp_weight, right_arm_supra))
                            let RSetsTemp = RSetsArray.map((S) => { return { R_reps: temp_reps, R_weight: temp_weight, R_torque: RightSetTorqueTemp } } );
                            // Ultilize the new Set Torque to get the total Torque for this workout
                            RightTorqueTemp = RSetsArray.length > 0 ? multiply(RightSetTorqueTemp, RSetsArray.length).toFixed(3) : 0;
                            ThisWorkout = { ...ThisWorkout, RTorque: RightTorqueTemp, RSets: RSetsTemp };
                        }
                    }
                    // For Workout/Program increase by weight, simply increase the weight and calculate the new set/workout torque. This else can apply to generating workouts where all 'increase by' inputs are blank
                    else {
                        let temp_reps = reps;
                        // Which workout number is being generated - for "last" it is 1 less than others
                        let workout_count = BaseState.program === 'last' ? workouts_array_index : workouts_array_index+1;
                        console.log({workout_count})
                        // If workout_count divided by the workouts_per_increase is an integer, perform the increase
                        let do_increase = BaseState.workouts_per_increase > 1 ? !isNaN(divide(workout_count, BaseState.workouts_per_increase)) && (function(x) { return (x | 0) === x; })(parseFloat(divide(workout_count, BaseState.workouts_per_increase))) : true;
                        console.log({do_increase})
                        if ( do_increase && BaseState.increase_weight_by !== '' && BaseState.torque_increase_type === 'exercise') {
                            temp_weight = add(temp_weight, BaseState.increase_weight_by).toFixed(1);
                        } else if ( do_increase && BaseState.increase_weight_by_program !== '' && BaseState.torque_increase_type === 'program') {
                            // Multiply whatever the fraction per workout would be for a pure division of increase_weight_by_program and workouts to generate, by the integer of this workout, to accurately increase weight in 0.1 minimum increments
                            let temp_divider = multiply(add(workouts_array_index,1), divide(BaseState.increase_weight_by_program,WorkoutsArray.length));
                            temp_weight = add(weight, temp_divider).toFixed(1);
                        }
                        console.log({temp_weight})
                        if ( left ) {
                            // Utilize this new weight and reps to calculate the torque of this workout
                            let LeftSetTorqueTemp = E === 'supra' ? multiply(temp_reps, temp_weight, left_arm_supra).toFixed(3) : multiply(temp_reps, temp_weight, left_forearm_other).toFixed(3);
                            let LSetsTemp = LSetsArray.map((S) => { return { L_reps: temp_reps, L_weight: temp_weight, L_torque: LeftSetTorqueTemp } } );
                            // Ultilize the new Set Torque to get the total Torque for this workout
                            LeftTorqueTemp = LSetsArray.length > 0 ? multiply(LeftSetTorqueTemp, LSetsArray.length).toFixed(3) : 0;
                            ThisWorkout = { ...ThisWorkout, LTorque: LeftTorqueTemp, LSets: LSetsTemp };
                        }
                        if ( right ) {
                            // Utilize this new weight and reps to calculate the torque of this workout
                            let RightSetTorqueTemp = E === 'supra' ? multiply(temp_reps, temp_weight, right_arm_supra).toFixed(3) : multiply(temp_reps, temp_weight, right_forearm_other).toFixed(3);
                            let RSetsTemp = RSetsArray.map((S) => { return { R_reps: temp_reps, R_weight: temp_weight, R_torque: RightSetTorqueTemp } } );
                            // Ultilize the new Set Torque to get the total Torque for this workout
                            RightTorqueTemp = RSetsArray.length > 0 ? multiply(RightSetTorqueTemp, RSetsArray.length).toFixed(3) : 0;
                            ThisWorkout = { ...ThisWorkout, RTorque: RightTorqueTemp, RSets: RSetsTemp };
                        }
                    }
                    // console.log("Final ThisWorkout: ", ThisWorkout);
                    Program.Workouts.filter((W) => W.exercise === E)[0].Workouts.push({ ...ThisWorkout, Torque: add(ThisWorkout.RTorque,ThisWorkout.LTorque).toFixed(3)});
                    // console.log("Final NewProgram: ", Program.Workouts.filter((W) => W.exercise === E)[0].Workouts);
                });
            });

        }
            console.log("Program.Workouts After TORQUES: ", Program.Workouts)
        if ( true ) {
        // Determine how many workouts will be generated, for loop that many
            // let i;
            // for ( i = 0; i < BaseState.number_of_workouts; i++ ) {
            //     console.log("Top i: ", i);
            //     let TempWorkout = [];
            //     // For each new Workout, reset the overall Workout specific torque calculations
            //     L_torque_total = 0;
            //     R_torque_total = 0;
            //     total_torque = 0;

            //     // Map through each selected Exercise
            //     Exercises.map((E) => {

            //         // Array of each Exercise's specific sets for this workout
            //         let ExerciseLSets = [];
            //         let ExerciseRSets = [];
            //         L_torque = 0;
            //         R_torque = 0;

            //         // Calculate the torque for each exercise by side
            //         if( E === 'supra' ) {

            //             // This set's torque calculations
            //             if ( left ) { L_torque = (L_arm/12)*0.7*reps*weight; }
            //             if ( right ) { R_torque = (R_arm/12)*0.7*reps*weight; }

            //             // Create a Workout object for each set
            //             let j;
            //             for ( j = 1; j <= sets; j++ ) {
            //                 let LSet = {};
            //                 let RSet = {};
            //                 if ( left ) {
            //                     LSet.L_reps = reps;
            //                     LSet.L_weight = weight;
            //                     LSet.L_torque = L_torque.toFixed(3);
            //                     // Push this set's details (reps/weight) to the array of this Exercise's Sets
            //                     ExerciseLSets.push(LSet)
            //                 }
            //                 if ( right ) {
            //                     RSet.R_reps = reps;
            //                     RSet.R_weight = weight;
            //                     RSet.R_torque = R_torque.toFixed(3);
            //                     // Push this set's details (reps/weight) to the array of this Exercise's Sets
            //                     ExerciseRSets.push(RSet)
            //                 }
            //             }
            //         } else {

            //             // This set's torque calculations
            //             if ( left ) { L_torque = (L_forearm/12)*reps*weight; }
            //             if ( right ) { R_torque = (R_forearm/12)*reps*weight; }

            //             // Create a Workout object for each set
            //             let j;
            //             for ( j = 1; j <= sets; j++ ) {
            //                 let LSet = {};
            //                 let RSet = {};
            //                 if ( left ) {
            //                     LSet.L_reps = reps;
            //                     LSet.L_weight = weight;
            //                     LSet.L_torque = L_torque.toFixed(3);
            //                     // Push this set's details (reps/weight) to the array of this Exercise's Sets
            //                     ExerciseLSets.push(LSet)
            //                 }
            //                 if ( right ) {
            //                     RSet.R_reps = reps;
            //                     RSet.R_weight = weight;
            //                     RSet.R_torque = R_torque.toFixed(3);
            //                     // Push this set's details (reps/weight) to the array of this Exercise's Sets
            //                     ExerciseRSets.push(RSet)
            //                 }
            //             }                
            //         }

            //         L_torque_total = L_torque*sets;
            //         R_torque_total = R_torque*sets;
            //         total_torque = L_torque_total + R_torque_total;


            //         // Push this Exercise's Sets to the TempWorkout array for this specific Workout
            //         TempWorkout.push({ exercise: E, LSets: ExerciseLSets, RSets: ExerciseRSets, LTorque: L_torque_total.toFixed(3), RTorque: R_torque_total.toFixed(3), Torque: total_torque.toFixed(3) });

            //     });

            //     console.log({TempWorkout})
            //     // Add these new Workouts to the existing array of Workouts
            //     Program.Workouts = Program.Workouts.map((W) => {
                
            //         let TempW = { ...W };
            //         console.log({TempW})
            //         // Get this Workout's Exercise from the TempWorkout array that was just generated
            //         let matching_exercise_index = TempWorkout.findIndex((TW) => TW.exercise === W.exercise );
            //         // Add the newly generated Workouts to the existing Program's Workouts for this exercise, if there were any Workouts for this exercise generated just now.
            //         if ( matching_exercise_index > -1 ) {
            //             // If only a single arm was added right now, check if there are existing workouts for this exercise that already have the other arm created, then add this current arm's new sets to that workout.
            //             if ( Arm.length === 1 && TempW.Workouts.length > i) {
            //                 console.log({i})
            //                 console.log("TempW.Workouts[i-1]: ", TempW.Workouts[i]);
            //                 // Handles a case of adding 3 right workouts, then 2 left workouts, then another 2 left workouts. This keeps adding to left as the 3rd and 4th workouts for the last 2 added.
            //                 let workouts_with_left_sets = 0;
            //                 let workouts_with_right_sets = 0;
            //                 TempW.Workouts.forEach((w) => {
            //                     if ( w.LSets.length > 0 ) workouts_with_left_sets = add(workouts_with_left_sets,1);
            //                     if ( w.RSets.length > 0 ) workouts_with_right_sets = add(workouts_with_right_sets,1);
            //                 });
            //                 // Check if there are Workouts for the other arm, but not this arm. If so, update this Workout number's Exercise's Workouts array for this current arm.
            //                 if ( Arm[0] === 'left' && TempW.Workouts[i].RSets.length > 0 && workouts_with_left_sets < workouts_with_right_sets ) {
            //                     TempW.Workouts[workouts_with_left_sets].LSets = TempWorkout[matching_exercise_index].LSets;
            //                 }
            //                 else if ( Arm[0] === 'right' && TempW.Workouts[i].LSets.length > 0 && workouts_with_left_sets > workouts_with_right_sets ) {
            //                     TempW.Workouts[workouts_with_right_sets].RSets = TempWorkout[matching_exercise_index].RSets;
            //                 }
            //                 else {
            //                     TempW.Workouts.push({LSets: TempWorkout[matching_exercise_index].LSets, RSets: TempWorkout[matching_exercise_index].RSets, LTorque: TempWorkout[matching_exercise_index].LTorque, RTorque: TempWorkout[matching_exercise_index].RTorque, Torque: TempWorkout[matching_exercise_index].Torque })
            //                 }
            //             } else {
            //                 TempW.Workouts.push({LSets: TempWorkout[matching_exercise_index].LSets, RSets: TempWorkout[matching_exercise_index].RSets, LTorque: TempWorkout[matching_exercise_index].LTorque, RTorque: TempWorkout[matching_exercise_index].RTorque, Torque: TempWorkout[matching_exercise_index].Torque})
            //             }
            //         }
                    
            //         return TempW;


            //     });


            //     console.log(Program.Workouts)
        // }
        }

        console.log({Program})

        setCalculatedWorkouts([ ...Program.Workouts ]);

        // Update the Workouts' Torques

        // Determine which exercise has the most workouts at this point, so we can generate that many in the UI
        let temp_workouts_count = 0;
        Program.Workouts.forEach((W) => {
            if ( W.Workouts.length > temp_workouts_count ) {
                temp_workouts_count = W.Workouts.length;
            }
        });
        setBaseState({ ...BaseState, workouts_count: temp_workouts_count, workout_generated: true })

    }

    // Determine if the Calculate Torque button should be disabled
    // function handleCalculateTorqueDisabled() {

    //     if ( Reps === 0 ) {
    //     Reps === 0 || Weight === '' || Weight === 0 || Weight === 0.0 || (Weight.includes('.') && Weight.split('.')[1].length === 0)
    //     }
    // }

    // Render the Workouts that have been generated by the Wizard
    function RenderGeneratedWorkouts() {
        let WorkoutsCount = [...Array(BaseState.workouts_count).keys()];
            return (
                <div className="mt-3">
                    <RenderWorkoutProgramButtons />
                    {WorkoutsCount.map((i) => {
                        return renderGeneratedWorkout(i)
                    })}
                    <RenderWorkoutProgramButtons />
                </div>
            ) 
    }

    // Render container of Save / Clear Workout Program
    function RenderWorkoutProgramButtons() {
        return (
            <div className="border-top border-3">
                <div className="clearfix my-3">
                    <div className="float-start">
                        <button className="btn btn-sm fw-bolder text-success border border-success border-3" onClick={() => handleSaveWorkoutProgram()}>
                            <FontAwesomeIcon icon={`${(BaseState.save_workout_program_button_text === 'Save' && 'fa-floppy-disk') || 'fa-check'}`} className="me-2" />{BaseState.save_workout_program_button_text} Workout Program
                        </button>
                    </div>
                    {/* <div className="">
                        <div className="form-floating col-auto">
                            <input className="form-control float" id="workout_program_name" value={SelectedWorkoutProgram.workout_program_name || ''} onChange={(event) => setSelectedWorkoutProgram({ ...SelectedWorkoutProgram, workout_program_name: event.target.value })} /> 
                            <label className="text-muted ms-2 h6" htmlFor="workout_program_name">Workout Program Name</label>
                        </div>
                    </div> */}
                    <div className="float-end">
                        <button className="btn btn-sm fw-bold col-auto border-secondary border-3 text-secondary float-end" onClick={() => handleCancelWorkoutProgram()} disabled={false}>
                            <FontAwesomeIcon icon="fa-times" className="me-2" />{BaseState.reset_workout_program_button_text}
                        </button>
                    </div>
                </div>
                {/* { BaseState.save_workout_program_message !== '' &&
                    <div className="alert alert-success alert-sm">{BaseState.save_workout_program_message}</div>
                } */}
            </div>
        )
    }
    console.log({SelectedWorkoutProgram})
    // Save function for the Workout Program
    async function handleSaveWorkoutProgram() {
        console.log("SAVE CLICKED: ");

        let SaveWorkoutProgramData = {...SelectedWorkoutProgram};

        // Parse string values that are IDs to be integers, saving stringified numbers to the database throws an error.
        let MakeIntegers = [ 'archiver_ID', 'creator_ID', 'customer_ID', 'updater_ID', 'user_ID', 'workout_program_ID' ];
        

        MakeIntegers.forEach((mi) => SaveWorkoutProgramData[mi] = parseInt(SaveWorkoutProgramData[mi]));

        // Remove save mesasge and button text from User object for saving
        // SaveWorkoutProgramData = _.omit(SaveWorkoutProgramData, ['date_last_benchmark','date_last_workout','save_button_text','save_message']);

        // Add creator_ID and customer_ID, or updater_ID depending on if there is a user_ID for the player being saved
        SaveWorkoutProgramData = parseInt(SaveWorkoutProgramData.user_ID) > 0 ? {...SaveWorkoutProgramData, updater_ID: parseInt(auth().User.user_ID)} : {...SaveWorkoutProgramData, creator_ID: parseInt(auth().User.user_ID), customer_ID: parseInt(auth().User.customer_ID), user_ID: parseInt(SelectedUser.user_ID)};
        console.log({SaveWorkoutProgramData})
        const result = await save_workout_program({ variables: { input: { ...SaveWorkoutProgramData } }});
        // Update the WorkoutProgram - save returns WorkoutProgram object
        console.log("Result 1: ", result.data)
        if(result.data && result.data.workoutProgramSave.WorkoutProgram) {
        console.log("Result: ", result.data.workoutProgramSave.WorkoutProgram)

            let temp_workout_program_ID = parseInt(result.data.workoutProgramSave.WorkoutProgram.workout_program_ID);
            // If this was a create, update the WorkProgram object with the new workout_program_ID
            if(parseInt(SaveWorkoutProgramData.workout_program_ID) === 0) {

                // Update the button and save message to show for created success
                setSelectedWorkoutProgram({
                    ...SelectedWorkoutProgram,
                    workout_program_ID: temp_workout_program_ID
                });

            } else {
            

                // Update the User with the new workout_program_ID that was created
                // setSelectedWorkoutProgram({
                //     ...SelectedWorkoutProgram,
                //     save_button_text: 'Saved',
                //     save_message: 'Successfully Updated'
                // });

            }

            // After saving workout_program, save the workout_program_sets. Need to convert the CalculatedWorkouts array to single objects that can be saved individually.
            // Loop Employees and loop their schedule to push ones without a time_clock_record_ID to the NewRecords array

            let NewRecords = [];
            CalculatedWorkouts.forEach((CW) => CW.Workouts.forEach((W, workout_index) => {
                // if ( true || parseInt(S.time_clock_record_ID) === 0 && parseInt(S.shift_ID) !== 0) 

                // On each Workout, create a new Set object (workout_program_sets) for the Left and Right arm on this Exercise (CW)
                W.LSets.forEach((S, index) => {
                    NewRecords.push({ 
                        workout_program_set_ID: 0,
                        workout_program_ID: parseInt(temp_workout_program_ID),
                        arm: 'L',
                        completed: 0,
                        creator_ID: parseInt(auth().User.user_ID),
                        date_created: null,
                        date_updated: null,
                        exercise: CW.exercise,
                        reps: parseInt(S.L_reps),
                        save_status: 0,
                        set_number: parseInt(index+1),
                        torque: S.L_torque,
                        updater_ID: 0,
                        weight: S.L_weight.toString(),
                        workout_number: parseInt(workout_index+1)
                    });
                });
                W.RSets.forEach((S, index) => {
                    NewRecords.push({ 
                        workout_program_set_ID: 0,
                        workout_program_ID: parseInt(temp_workout_program_ID),
                        arm: 'R',
                        completed: 0,
                        creator_ID: parseInt(auth().User.user_ID),
                        date_created: null,
                        date_updated: null,
                        exercise: CW.exercise,
                        reps: parseInt(S.R_reps),
                        save_status: 0,
                        set_number: parseInt(index+1),
                        torque: S.R_torque,
                        updater_ID: 0,
                        weight: S.R_weight.toString(),
                        workout_number: parseInt(workout_index+1)
                    });
                });
            }));

            console.log({NewRecords});

            if ( NewRecords.length > 0 ) {
                const result = await save_workout_program_sets({ variables: { input: { WorkoutProgramSets: [ ...NewRecords ] } } });
                
                console.log("Result Sets Save: ", result)
                if(result.data && result.data.workoutProgramSetsSave.WorkoutProgramSets) {
                    console.log("Result Sets Data: ", result.data.workoutProgramSetsSave.WorkoutProgramSets)

                    setBaseState({
                        ...BaseState,
                        save_workout_program_button_text: 'Saved', workout_generated: false
                    });
                }
            } else {
                setBaseState({
                    ...BaseState,
                    save_workout_program_message: 'No new records to save to Workout Program', workout_generated: false
                });
            }

            // // For insert and update, set the action and new Users
            // setBaseState({
            //     ...BaseState,
            //     action: temp_action,
            //     Users: TempUsers
            // });

            // // Update the User in the parent component's list of Users
            // props.handleChangeParentBaseState(props.action, TempUsers)
        }
    }

    // Clear/Cancel function for the Workout Program
    async function handleCancelWorkoutProgram() {
        console.log("CANCEL CLICKED");
        setCalculatedWorkouts(DefaultCalculatedWorkouts);
        setBaseState({ ...BaseState, save_workout_program_button_text: 'Save', save_workout_program_message: '', workouts_count: 0, workout_generated: false });
    }

    // Handler for select of Workout Program
    async function handleProgramSelection(program) {
        console.log({program})
        console.log({BaseState})
        // Reset any previously calculated workout programs
        setCalculatedWorkouts([...DefaultCalculatedWorkouts]);
        setLastWorkoutCalculation([...DefaultCalculatedWorkouts]);
        let NewState = { ...BaseState, program, workouts_count: 0, Exercises: ['supra'], Arm: ['right', 'left'] };

        // If 'Build From Last' is selected, we need to utilize the LastWorkout's data for building out the Workout Program
        if ( program === 'last' ) {
            NewState = { ...NewState, Exercises: [] };
            console.log({NewState})
            // const workouts = ['supra', 'infra', 'teres', 'subscap', 'house'];
            // const capitalized = ['Supra', 'Infra', 'Teres Minor', 'Subscap', 'House Combo'];
            // const reps = [1,2,3,4,5];
            let L_arm = SelectedUser.arm_length_left;
            let R_arm = SelectedUser.arm_length_right;
            let L_forearm = SelectedUser.forearm_length_left;
            let R_forearm = SelectedUser.forearm_length_right;
            console.log({L_arm})
            console.log({R_arm})
            console.log({L_forearm})
            console.log({R_forearm})
            // Calculate the arm component of torque calculations for reuseability
            let left_arm_supra = L_arm > 0 ? multiply(0.7, divide(L_arm, 12)) : 0;
            let right_arm_supra = R_arm > 0 ? multiply(0.7, divide(R_arm, 12)) : 0;
            let left_forearm_other = L_forearm > 0 ? divide(L_forearm, 12) : 0;
            let right_forearm_other = R_forearm > 0 ? divide(R_forearm, 12) : 0;
            console.log({left_arm_supra})
            console.log({right_arm_supra})
            console.log({left_forearm_other})
            console.log({right_forearm_other})

            let TempLastWorkoutCalculation = [ ...LastWorkoutCalculation ];
            console.log({TempLastWorkoutCalculation})
            // Loop over each of the 5 const workouts, and map the user's last workout to our LastWorkoutCalculation structure
            workouts.forEach((w, index) => {
                console.log({w})
                let temp_w = w === 'house' ? 'surfer' : w;
                let TempWorkout = { exercise: w, Workouts: [ { LSets: [], LTorque: 0, RSets: [], RTorque: 0, Torque: 0  } ] };
                
                let TempLSets = [];
                let TempLTorque = 0;
                let TempRSets = [];
                let TempRTorque = 0;

                let add_exercise = false;
                reps.forEach((r) => {
                    // Only show rep line if there were actual reps performed
                    console.log("LastWorkout[`L${r}_rep_${w}`]: ", LastWorkout[`L${r}_rep_${temp_w}`])
                    if ( LastWorkout[`L${r}_rep_${temp_w}`] !== 0 ) {
                        let temp_L_reps = `${LastWorkout[`L${r}_rep_${temp_w}`]}`;
                        let temp_L_weight = `${LastWorkout[`L${r}_weight_${temp_w}`]}`;
                        console.log({temp_L_reps})
                        console.log({temp_L_weight})
                        let temp_L_torque = w === 'supra' ? multiply(temp_L_reps,temp_L_weight,left_arm_supra).toFixed(3) : multiply(temp_L_reps,temp_L_weight,left_forearm_other).toFixed(3);
                        TempLTorque = add(TempLTorque, temp_L_torque);
                        TempLSets.push({ L_reps: temp_L_reps, L_weight: temp_L_weight, L_torque: temp_L_torque });
                        add_exercise = true;
                    }
                    console.log("LastWorkout[`R${r}_rep_${temp_w}`]: ", LastWorkout[`R${r}_rep_${temp_w}`])
                    if ( LastWorkout[`R${r}_rep_${temp_w}`] !== 0 ) {
                        let temp_R_reps = `${LastWorkout[`R${r}_rep_${temp_w}`]}`;
                        let temp_R_weight = `${LastWorkout[`R${r}_weight_${temp_w}`]}`;
                        console.log({temp_R_reps})
                        console.log({temp_R_weight})
                        let temp_R_torque = w === 'supra' ? multiply(temp_R_reps,temp_R_weight,right_arm_supra).toFixed(3) : multiply(temp_R_reps,temp_R_weight,right_forearm_other).toFixed(3);
                        TempRTorque = add(TempRTorque, temp_R_torque);
                        TempRSets.push({ R_reps: temp_R_reps, R_weight: temp_R_weight, R_torque: temp_R_torque });
                        add_exercise = true;
                    }                    
                });

                // Pre-select the Exercises that are already in this workout
                if ( add_exercise ) {
                    NewState.Exercises.push(w);
                }
                TempWorkout = { ...TempWorkout, Workouts: [ { LSets: TempLSets, LTorque: TempLTorque, RSets: TempRSets, RTorque: TempRTorque, Torque: add(TempLTorque,TempRTorque).toFixed(3)  } ] };

                TempLastWorkoutCalculation = TempLastWorkoutCalculation.map((TCW) => {
                    if (TCW.exercise === TempWorkout.exercise) {
                        return TempWorkout;
                    } else {
                        return TCW;
                    }
                })
            });
            // This Last Workout can now be used moving forward for calculations of Workout Programs
            setLastWorkoutCalculation([...TempLastWorkoutCalculation])
        }
        else if ( program === 'recovery' ) {
            NewState = { ...NewState, Exercises: ['supra','infra','teres','subscap','house'], number_of_workouts: 2, reps: 20, sets: 2, weight: 5 };
        }
        else if ( program === 'created' ) {
            console.log("parseInt(SelectedUser.user_ID): ", parseInt(SelectedUser.user_ID))
            let TempWorkoutPrograms = await get_workout_programs({ variables: { user_ID: parseInt(SelectedUser.user_ID) } });
            console.log({TempWorkoutPrograms});

            // Set this User's PTCs, otherwise if there are none or there was an issue, set them to an empty array
            if ( TempWorkoutPrograms.data && TempWorkoutPrograms.data.workout_programs ) {
                setWorkoutPrograms([ ...TempWorkoutPrograms.data.workout_programs ]);
            } else {
                setWorkoutPrograms([]);
            }
        }
        setBaseState({ ...NewState, workout_generated: false });
    }
    console.log({WorkoutPrograms})
    // Render NO SETS badge
    function RenderNoSets() {
        return <span className="badge rounded-pill border border-secondary bg-white text-secondary">No Sets</span>
    }

    // Render single Workout generated by Wizard
    function renderGeneratedWorkout(workout_number) {
        // Calculate the total torque for this workout
        let total_workout_torque = 0;
        CalculatedWorkouts.forEach((E) => {
            if ( E.Workouts.length > 0 && E.Workouts[workout_number] ) {
                total_workout_torque = add( total_workout_torque, add( E.Workouts[workout_number].LTorque, E.Workouts[workout_number].RTorque ) );
            }
        });
        return (
            <>
                <div className="border-bottom border-3 mb-2 mt-5 clearfix">
                    <div className="float-start">Workout {workout_number+1}</div>
                    <div className="float-end"><span className="text-muted" style={{fontSize: '80%'}}>Total Work Performed: </span>{total_workout_torque.toFixed(3)} ft-lbs</div>
                </div>
                <div className="mt-3">
                    {
                        workouts.map((E, index) => {
                            // console.log("CalculatedWorkouts[index].Workouts: ", CalculatedWorkouts[index].Workouts)
                            // console.log("CalculatedWorkouts[index].Workouts[workout_number]: ", CalculatedWorkouts[index].Workouts[workout_number])
                            let this_workout_has_sets = CalculatedWorkouts[index].Workouts.length > 0;
                            let L_sets_count = 0;
                            let R_sets_count = 0;
                            let max_sets = 0;
                            let SetsArray = [...Array(0).keys()];
                            if ( this_workout_has_sets && CalculatedWorkouts[index].Workouts[workout_number] != undefined) {
                                // console.log("CalculatedWorkouts[index].Workouts[workout_number]: ", CalculatedWorkouts[index].Workouts[workout_number])
                                L_sets_count = CalculatedWorkouts[index].Workouts[workout_number].LSets.length;
                                R_sets_count = CalculatedWorkouts[index].Workouts[workout_number].RSets.length;
                                max_sets = L_sets_count > R_sets_count ? L_sets_count : R_sets_count;
                                SetsArray = [...Array(max_sets).keys()];
                            }
                            return (
                                <div className="mb-3" key={index}>
                                    <div className={`row ${(true && 'border-bottom border-1') || false}`} style={{fontSize: 75+'%'}}>
                                        <div className="col-4">
                                            {E === 'supra' && 'Supra'}
                                            {E === 'infra' && 'Infra'}
                                            {E === 'teres' && 'Teres Minor'}
                                            {E === 'subscap' && 'Subscab'}
                                            {E === 'house' && 'House Combo'}
                                            {this_workout_has_sets && CalculatedWorkouts[index].Workouts[workout_number] != undefined && <div className="text-muted">{CalculatedWorkouts[index].Workouts[workout_number].Torque} ft-lbs</div>}
                                        </div>
                                        <div className="col-4">Left {L_sets_count > 0 && <div className="text-muted">{CalculatedWorkouts[index].Workouts[workout_number].LTorque} ft-lbs</div>}</div>
                                        <div className="col-4">Right {R_sets_count > 0 && <div className="text-muted">{CalculatedWorkouts[index].Workouts[workout_number].RTorque} ft-lbs</div>}</div>
                                    </div>
                                    <div className="mb-2">
                                        <table className="table table-hover h6">
                                            <tbody>
                                            {
                                                this_workout_has_sets && 
                                                SetsArray.map((S) => {
                                                    let LSet = CalculatedWorkouts[index].Workouts[workout_number].LSets[S];
                                                    let RSet = CalculatedWorkouts[index].Workouts[workout_number].RSets[S];
                                                    return (
                                                        <>
                                                            <tr className="row border-0" onMouseEnter={() => console.log("Enter: ", S)} onMouseLeave={() => console.log("Leave: ", S)} key={S}>
                                                                <td className="col-4 border-0">{S+1}</td>
                                                                <td className="col-4 border-0">
                                                                    { LSet && <span className="w-full">{LSet.L_reps} x {LSet.L_weight} lbs. <span className="text-muted float-end me-5" style={{fontSize: 100+'%'}}>{LSet.L_torque} ft-lbs</span></span>}
                                                                    { !LSet &&  <RenderNoSets />}
                                                                </td>
                                                                <td className="col-4 border-0">
                                                                    { RSet && <span className="w-full">{RSet.R_reps} x {RSet.R_weight} lbs. <span className="text-muted float-end me-5" style={{fontSize: 100+'%'}}>{RSet.R_torque} ft-lbs</span></span>}
                                                                    { !RSet &&  <RenderNoSets />}
                                                                </td>
                                                            </tr>
                                                            {/* {
                                                                S > 1 && ( S+1 == SetsArray.length) &&
                                                                <tr className="row border-top">
                                                                    <td className="col-4 border-0">Total: <span className="text-muted">{CalculatedWorkouts[index].Workouts[workout_number].Torque} ft-lbs</span></td>
                                                                    <td className="col-4 border-0">Left: <span className="text-muted">{CalculatedWorkouts[index].Workouts[workout_number].LTorque} ft-lbs</span></td>
                                                                    <td className="col-4 border-0">Right: <span className="text-muted">{CalculatedWorkouts[index].Workouts[workout_number].RTorque} ft-lbs</span></td>
                                                                </tr>
                                                            } */}
                                                        </>
                                                    )
                                                })
                                            }
                                            {
                                                !this_workout_has_sets &&
                                                <tr className="row border-0" >
                                                    <td className="col-4 border-0">
                                                        {/* <button className="btn btn-sm fw-bolder text-success border border-success border-3" 
                                                            // disabled={Reps === 0 || Weight === '' || Weight === 0 || Weight === 0.0 } 
                                                            onClick={() => handleGenerateWorkouts()}>
                                                            <FontAwesomeIcon icon="fa-plus" className="me-2" />Add Set
                                                        </button> */}
                                                    </td>
                                                    <td className="col-4 border-0"><RenderNoSets /></td>
                                                    <td className="col-4 border-0"><RenderNoSets /></td>
                                                </tr>
                                            }
                                            </tbody>
                                        </table>
                                    </div>

                                </div>
                            )
                        })
                    }
                </div>
            </>
        )
    }

    // Render the selection buttons for the exercises 
    function RenderExerciseSelections() {
        return (
            <div className="btn-group btn-group-sm w-full" role="group">
                <button className={`btn btn-outline-secondary text-dark}`} onClick={() => handleSetExercises('all')}>
                    All
                </button>
                <button className={`btn btn-outline-secondary ${(BaseState.Exercises.findIndex((E) => E === 'supra') > -1 && 'btn-secondary text-white border border-dark') || 'text-dark'}`} onClick={() => handleSetExercises('supra')}>
                    Supra
                </button>
                <button className={`btn btn-outline-secondary ${(BaseState.Exercises.findIndex((E) => E === 'infra') > -1 && 'btn-secondary text-white border border-dark') || 'text-dark'}`} onClick={() => handleSetExercises('infra')}>
                    Infra
                </button>
                <button className={`btn btn-outline-secondary ${(BaseState.Exercises.findIndex((E) => E === 'teres') > -1 && 'btn-secondary text-white border border-dark') || 'text-dark'}`} onClick={() => handleSetExercises('teres')}>
                    Teres Minor
                </button>
                <button className={`btn btn-outline-secondary ${(BaseState.Exercises.findIndex((E) => E === 'subscap') > -1 && 'btn-secondary text-white border border-dark') || 'text-dark'}`} onClick={() => handleSetExercises('subscap')}>
                    Subscap
                </button>
                <button className={`btn btn-outline-secondary ${(BaseState.Exercises.findIndex((E) => E === 'house') > -1 && 'btn-secondary text-white border border-dark') || 'text-dark'}`} onClick={() => handleSetExercises('house')}>
                    House Combo
                </button>
            </div>                            
        )
    }

    // Render user's Generated Workout Programs
    function RenderCreatedPrograms() {
        console.log({SelectedCreatedProgram})
        return (
            <div className="h6">
                <table className="table table-striped table-hover">
                    <thead className="">
                        <tr className="row">
                            <th className="col">Created</th>
                            <th className="col">Program Name</th>
                            <th className="col">Total Workouts</th>
                            {/* <th className="col">Active</th> */}
                        </tr>
                    </thead>
                    <tbody>
                        {
                            WorkoutPrograms.map((WP) => {
                                let temp_total_workouts_count = 0;
                                WP.WorkoutProgramSets.forEach((WPS) => {
                                    if ( WPS.workout_number > temp_total_workouts_count ) temp_total_workouts_count = WPS.workout_number;
                                });
                                return (
                                    <>
                                        <tr className="row" key={WP.workout_program_ID} onClick={() => setSelectedCreatedProgram(WP)}>
                                            <td className="col">
                                                {dayjs(WP.date_created).format('M-D-YY')}
                                            </td>
                                            <td className="col">{WP.workout_program_name}</td>
                                            <td className="col">{temp_total_workouts_count}</td>
                                            {/* <td className="col">
                                                {WP.active === 0 && <span className="badge rounded-pill border border-danger bg-white text-danger">INACTIVE</span>}
                                                {WP.active === 1 && <span className="badge rounded-pill border border-success bg-white text-success">ACTIVE</span>}
                                            </td> */}
                                        </tr>
                                        {/* If this Program is selected, show its details */}
                                        {
                                            SelectedCreatedProgram.workout_program_ID && parseInt(SelectedCreatedProgram.workout_program_ID) === parseInt(WP.workout_program_ID) &&
                                            <tr className="row" key={-1}>
                                                <td className="col" colSpan={4}>
                                                    <RenderCreatedProgram WP={WP} temp_total_workouts_count={temp_total_workouts_count} />
                                                </td>
                                            </tr>
                                        }
                                    </>
                                )
                            })
                        }
                    </tbody>
                </table>
            </div>
        )
    }

    // Render details about a single Created/Generate Workout Program in the "Created Programs" tab
    function RenderCreatedProgram({WP, temp_total_workouts_count}) {
        console.log({WP})
        console.log({temp_total_workouts_count})
        let WorkoutsCountArray = [...Array(temp_total_workouts_count).keys()];
        // 
        // Calculate the total torque for this workout
        // let total_workout_torque = 0;
        // CalculatedWorkouts.forEach((E) => {
        //     console.log({E})
        //     if ( E.Workouts.length > 0 && E.Workouts[workout_number] ) {
        //         total_workout_torque = add( total_workout_torque, add( E.Workouts[workout_number].LTorque, E.Workouts[workout_number].RTorque ) );
        //     }
        // });

        return WorkoutsCountArray.map((W) => {
            return (
                <>
                    <div className="border-bottom border-3 mb-2 mt-5 h4 clearfix">
                        <div className="float-start">Workout {W+1}</div>
                        {/* <div className="float-end"><span className="text-muted" style={{fontSize: '80%'}}>Total Work Performed: </span>{total_workout_torque.toFixed(3)} ft-lbs</div> */}
                    </div>
                    <div className="mt-3">
                        {
                            workouts.map((E, index) => {
                                // Get all of the WorkoutProgramSets for this exercise, for this workout_number
                                let ExerciseSets = WP.WorkoutProgramSets.filter((WPS) => WPS.exercise === E && WPS.workout_number === W+1);
                                console.log({ExerciseSets})

                                // console.log("CalculatedWorkouts[index].Workouts: ", CalculatedWorkouts[index].Workouts)
                                // console.log("CalculatedWorkouts[index].Workouts[workout_number]: ", CalculatedWorkouts[index].Workouts[workout_number])
                                let this_workout_has_sets = ExerciseSets.length > 0;
                                let L_sets_count = 0;
                                let R_sets_count = 0;
                                let max_sets = 0;
                                let SetsArray = [...Array(5).keys()];
                                // if ( this_workout_has_sets 
                                //     // && CalculatedWorkouts[index].Workouts[workout_number] != undefined
                                // ) {
                                //     L_sets_count = CalculatedWorkouts[index].Workouts[workout_number].LSets.length;
                                //     R_sets_count = CalculatedWorkouts[index].Workouts[workout_number].RSets.length;
                                //     max_sets = L_sets_count > R_sets_count ? L_sets_count : R_sets_count;
                                //     SetsArray = [...Array(max_sets).keys()];
                                // }
                                return (
                                    <div className="mb-3" key={index}>
                                        <div className={`row h5 ${(true && 'border-bottom border-1') || false}`}>
                                            <div className="col-4">
                                                {E === 'supra' && 'Supra'}
                                                {E === 'infra' && 'Infra'}
                                                {E === 'teres' && 'Teres Minor'}
                                                {E === 'subscap' && 'Subscab'}
                                                {E === 'house' && 'House Combo'}
                                                {/* {this_workout_has_sets && CalculatedWorkouts[index].Workouts[workout_number] != undefined && <div className="text-muted">{CalculatedWorkouts[index].Workouts[workout_number].Torque} ft-lbs</div>} */}
                                            </div>
                                            <div className="col-4">Left 
                                            {/* {L_sets_count > 0 && <div className="text-muted">{CalculatedWorkouts[index].Workouts[workout_number].LTorque} ft-lbs</div>} */}
                                            </div>
                                            <div className="col-4">Right 
                                            {/* {R_sets_count > 0 && <div className="text-muted">{CalculatedWorkouts[index].Workouts[workout_number].RTorque} ft-lbs</div>} */}
                                            </div>
                                        </div>
                                        <div className="mb-2">
                                            <table className="table table-hover h6">
                                                <tbody>
                                                {
                                                    this_workout_has_sets && 
                                                    SetsArray.map((S) => {
                                                        let LSet = ExerciseSets.filter((ES) => ES.set_number === S+1 && ES.arm === 'L');
                                                        let RSet = ExerciseSets.filter((ES) => ES.set_number === S+1 && ES.arm === 'R');

                                                        if ( LSet.length > 0 || RSet.length > 0 ) {
                                                            return (
                                                                <>
                                                                    <tr className="row border-0" key={S}>
                                                                        <td className="col-4 border-0">{S+1}</td>
                                                                        <td className="col-4 border-0">
                                                                            { LSet.length > 0 && <span className="w-full">{LSet[0].reps} x {LSet[0].weight} lbs. <span className="text-muted float-end me-5 pe-5" style={{fontSize: 100+'%'}}>{LSet[0].torque} ft-lbs</span></span>}
                                                                            { LSet.length === 0 &&  <RenderNoSets />}
                                                                        </td>
                                                                        <td className="col-4 border-0">
                                                                            { RSet.length > 0 && <span className="w-full">{RSet[0].reps} x {RSet[0].weight} lbs. <span className="text-muted float-end me-5 pe-5" style={{fontSize: 100+'%'}}>{RSet[0].torque} ft-lbs</span></span>}
                                                                            { RSet.length === 0 &&  <RenderNoSets />}
                                                                        </td>
                                                                    </tr>
                                                                    {/* {
                                                                        S > 1 && ( S+1 == SetsArray.length) &&
                                                                        <tr className="row border-top">
                                                                            <td className="col-4 border-0">Total: <span className="text-muted">{CalculatedWorkouts[index].Workouts[workout_number].Torque} ft-lbs</span></td>
                                                                            <td className="col-4 border-0">Left: <span className="text-muted">{CalculatedWorkouts[index].Workouts[workout_number].LTorque} ft-lbs</span></td>
                                                                            <td className="col-4 border-0">Right: <span className="text-muted">{CalculatedWorkouts[index].Workouts[workout_number].RTorque} ft-lbs</span></td>
                                                                        </tr>
                                                                    } */}
                                                                </>
                                                            )
                                                        } else {
                                                            return null;
                                                        }
                                                    })
                                                }
                                                {/* {
                                                    !this_workout_has_sets &&
                                                    <tr className="row border-0" >
                                                        <td className="col-4 border-0">
                                                            <button className="btn btn-sm fw-bolder text-success border border-success border-3" 
                                                                // disabled={Reps === 0 || Weight === '' || Weight === 0 || Weight === 0.0 } 
                                                                onClick={() => handleGenerateWorkouts()}>
                                                                <FontAwesomeIcon icon="fa-plus" className="me-2" />Add Set
                                                            </button>
                                                        </td>
                                                        <td className="col-4 border-0"><RenderNoSets /></td>
                                                        <td className="col-4 border-0"><RenderNoSets /></td>
                                                    </tr>
                                                } */}
                                                </tbody>
                                            </table>
                                        </div>

                                    </div>
                                )
                            })
                        }
                    </div>
                </>
            )
        });
    }

    console.log({BaseState})
    console.log({CalculatedWorkouts})
    console.log({LastWorkout})
    return (
        <div className="clearfix">
            <div className="card h-100">
                <div className="card-header h5 border border-secondary">
                    <div className="clearfix">
                        <span className="float-start mt-1">Workout Wizard</span>
                    </div>
                </div>
                <div className="card-body border border-secondary border-top-0">
                    {/* MUST HAVE ARM MEASUREMENTS TO USE THE WIZARD */}
                    {
                        has_measurements &&
                        <>
                            <>
                            {/* 
                            <div className="">
                                {
                                    workouts.map((w, index) => {
                                        return (
                                            <>
                                                <div className="row h6">
                                                    <div className="col-4 h5">
                                                        {capitalized[index]}
                                                    </div>
                                                    <div className="col-4">
                                                        Left Arm
                                                            {
                                                                reps.map((r) => {
                                                                    // Only show rep line if there were actual reps performed
                                                                    if ( LastWorkout[`L${r}_rep_${w}`] !== 0 ) {
                                                                        return (
                                                                            <div className="clearfix" key={r}>
                                                                                {LastWorkout[`L${r}_weight_${w}`]} lbs x {LastWorkout[`L${r}_rep_${w}`]}
                                                                            </div>
                                                                        )
                                                                    } else {
                                                                        return null;
                                                                    }
                                                                })
                                                            }
                                                    </div>
                                                    <div className="col-4">
                                                        Right Arm
                                                            {
                                                                reps.map((r) => {
                                                                    // Only show rep line if there were actual reps performed
                                                                    if ( LastWorkout[`R${r}_rep_${w}`] !== 0 ) {
                                                                        return (
                                                                            <div className="clearfix" key={r}>
                                                                                {LastWorkout[`R${r}_weight_${w}`]} lbs x {LastWorkout[`R${r}_rep_${w}`]}
                                                                            </div>
                                                                        )
                                                                    } else {
                                                                        return null;
                                                                    }
                                                                })
                                                            }
                                                    </div>
                                                </div>
                                            </>
                                        )
                                    })
                                }                    
                            </div> 
                        */}
                            </> 

                            <div className="row clearfix justify-content-center">
                                {/* NEW WORKOUT, OR USE LAST WORKOUT */}
                                {/* <div className="col-12 text-center mb-2" style={{fontSize: '75%',  whiteSpace: 'nowrap'}}>Choose to create a new workout program, or build off the last workout</div> */}
                                <div className="col-12 mb-3">
                                    <div className="btn-group btn-group-sm row w-100 mx-0" role="group">
                                        <button className={`btn btn-outline-secondary col-3 ${(BaseState.program === 'new' && 'btn-secondary text-white border border-dark') || 'text-dark'}`} onClick={() => handleProgramSelection('new')}>
                                            New Program
                                        </button>
                                        <button className={`btn btn-outline-secondary col-3 ${(BaseState.program === 'last' && 'btn-secondary text-white border border-dark') || 'text-dark'}`} onClick={() => handleProgramSelection('last')}>
                                            Build From Last
                                        </button>
                                        <button className={`btn btn-outline-secondary col-3 ${(BaseState.program === 'recovery' && 'btn-secondary text-white border border-dark') || 'text-dark'}`} onClick={() => handleProgramSelection('recovery')}>
                                            Recovery
                                        </button>
                                        <button className={`btn btn-outline-secondary col-3 ${(BaseState.program === 'created' && 'btn-secondary text-white border border-dark') || 'text-dark'}`} onClick={() => handleProgramSelection('created')}>
                                            Created Programs
                                        </button>
                                    </div>                            
                                </div>

                                {/* NEW WORKOUT */}
                                {
                                    BaseState.program === 'new' &&
                                    <>
                                        {/* SETS, REPS, WEIGHT SELECTION */}
                                        <div className="col-12 text-center mb-2" style={{fontSize: '75%',  whiteSpace: 'nowrap'}}>Choose initial workout's Sets, Reps, and Weight</div>
                                        <div className="form-floating col-4">
                                            <select 
                                                className="form-select" 
                                                disabled={!has_measurements}
                                                id="sets"
                                                onChange={(event) => setBaseState({ ...BaseState, sets: parseInt(event.target.value), workout_generated: false })}
                                                placeholder="Sets"
                                                value={BaseState.sets}
                                            >
                                                <option value={1}>1</option>
                                                <option value={2}>2</option>
                                                <option value={3}>3</option>
                                                <option value={4}>4</option>
                                                <option value={5}>5</option>
                                            </select> 
                                            <label className="text-muted ms-2 h6" htmlFor="sets">Sets</label>
                                        </div>
                                        <div className="form-floating col-4">
                                            <input className="form-control float" disabled={!has_measurements} id="reps" value={BaseState.reps} onChange={(event) => changeInputValue('reps', event.target.value)} /> 
                                            <label className="text-muted ms-2 h6" htmlFor="reps">Reps</label>
                                        </div>
                                        <div className="form-floating col-4">
                                            <input className="form-control float" disabled={!has_measurements} id="weight" value={BaseState.weight} onChange={(event) => changeInputValue('weight', event.target.value)} /> 
                                            <label className="text-muted ms-2 h6" htmlFor="weight">Weight (lbs - 0.1)</label>
                                        </div>

                                        <div className="col-12 text-center mb-2 mt-3" style={{fontSize: '75%',  whiteSpace: 'nowrap'}}>Choose one or both arms.</div>

                                        {/* ARM */}
                                        <div className="col-auto">
                                            <div className="btn-group btn-group-sm" role="group">
                                                <button className={`btn btn-outline-secondary w-auto ${(BaseState.Arm.findIndex((A) => A === 'left') > -1 && 'btn-secondary text-white border border-dark') || 'text-dark'}`} onClick={() => handleSetArm('left')}>
                                                    Left
                                                </button>
                                                <button className={`btn btn-outline-secondary w-auto ${(BaseState.Arm.findIndex((A) => A === 'right') > -1 && 'btn-secondary text-white border border-dark') || 'text-dark'}`} onClick={() => handleSetArm('right')}>
                                                    Right
                                                </button>
                                            </div>                            
                                        </div>

                                        {/* EXERCISE */}
                                        <div className="col-12 text-center mb-2 mt-3" style={{fontSize: '75%',  whiteSpace: 'nowrap'}}>Choose one, multiple, or all exercises.</div>
                                        <div className="col-auto text-center">
                                            <RenderExerciseSelections />
                                        </div>
                                    </>
                                }

                                {/* BUILD FROM LAST WORKOUT */}
                                {
                                    BaseState.program === 'last' &&
                                    <>
                                        {
                                            LastWorkout.index > -1 &&
                                            <div style={{fontSize: 75+'%'}}>
                                                <div className="alert alert-info">
                                                    <ul>
                                                        <li>This person's last Workout details are shown below.</li>
                                                        <li>The Workout Wizard will build off of this Workout's data.</li>
                                                        <li>If you'd like the new Workout Program to have significantly different Reps, Sets, or Weights than this last Workout, you may consider using the "New Program's" customization features.</li>
                                                    </ul>
                                                </div>
                                                <WorkoutDetailsComponent
                                                    called_from={'wizard'}
                                                    SelectedWorkout={LastWorkout}
                                                    SelectedUser={SelectedUser}
                                                    Workouts={Workouts}
                                                />

                                                {/* EXERCISE */}
                                                <div className="col-12 text-center mb-2 mt-3" style={{ whiteSpace: 'nowrap'}}>Choose one, multiple, or all exercises.</div>
                                                <div className="col-auto text-center">
                                                    <RenderExerciseSelections />
                                                </div>

                                            </div>
                                        }
                                        {
                                            LastWorkout.index === -1 &&
                                            <div style={{fontSize: 75+'%'}}>
                                                <div className="alert alert-info text-center">
                                                    <div>There is not a last Workout to build a Workout Program from</div>
                                                    <div>Please use "New Program".</div>
                                                </div>
                                            </div>
                                        }
                                        {/* 
                                            show all exercises, and last workout's sets, reps, weights
                                            ability to add new / remove sets, change reps, weights, and reset individual data pieces to original data
                                        */}
                                    </>
                                }

                                {/* RECOVERY WORKOUT */}
                                {
                                    BaseState.program === 'recovery' &&
                                    <>
                                        {/* 
                                            show option for football, baseball.
                                            show weight of ball
                                            show yards per throw
                                        */}
                                        {/* SETS, REPS, WEIGHT SELECTION */}
                                        <div className="col-12 text-center mb-2"><div className="alert alert-info">Create this week's Workout Program for Recovery from training</div></div>
                                        <div className="col-12 text-center mb-2" style={{fontSize: '75%',  whiteSpace: 'nowrap'}}>Choose initial workout's Sets, Reps, and Weight</div>
                                        <div className="col-12 text-center mb-2" style={{fontSize: '60%',  whiteSpace: 'nowrap'}}>Recommended to use 2 Sets for In-Season, 3 Sets for Off-Season</div>
                                        <div className="form-floating col-4">
                                            <select 
                                                className="form-select" 
                                                disabled={!has_measurements}
                                                id="sets"
                                                onChange={(event) => setBaseState({ ...BaseState, sets: parseInt(event.target.value), workout_generated: false })}
                                                placeholder="Sets"
                                                value={BaseState.sets}
                                            >
                                                <option value={1}>1</option>
                                                <option value={2}>2</option>
                                                <option value={3}>3</option>
                                                <option value={4}>4</option>
                                                <option value={5}>5</option>
                                            </select> 
                                            <label className="text-muted ms-2 h6" htmlFor="sets">Sets</label>
                                        </div>
                                        <div className="form-floating col-4">
                                            <input className="form-control float" disabled={!has_measurements} id="reps" value={BaseState.reps} onChange={(event) => changeInputValue('reps', event.target.value)} /> 
                                            <label className="text-muted ms-2 h6" htmlFor="reps">Reps</label>
                                        </div>
                                        <div className="form-floating col-4">
                                            <input className="form-control float" disabled={!has_measurements} id="weight" value={BaseState.weight} onChange={(event) => changeInputValue('weight', event.target.value)} /> 
                                            <label className="text-muted ms-2 h6" htmlFor="weight">Weight (lbs - 0.1)</label>
                                        </div>

                                        <div className="col-12 text-center mb-2 mt-3" style={{fontSize: '75%',  whiteSpace: 'nowrap'}}>Choose one or both arms.</div>

                                        {/* ARM */}
                                        <div className="col-auto">
                                            <div className="btn-group btn-group-sm" role="group">
                                                <button className={`btn btn-outline-secondary w-auto ${(BaseState.Arm.findIndex((A) => A === 'left') > -1 && 'btn-secondary text-white border border-dark') || 'text-dark'}`} onClick={() => handleSetArm('left')}>
                                                    Left
                                                </button>
                                                <button className={`btn btn-outline-secondary w-auto ${(BaseState.Arm.findIndex((A) => A === 'right') > -1 && 'btn-secondary text-white border border-dark') || 'text-dark'}`} onClick={() => handleSetArm('right')}>
                                                    Right
                                                </button>
                                            </div>                            
                                        </div>

                                        {/* EXERCISE */}
                                        <div className="col-12 text-center mb-2 mt-3" style={{fontSize: '75%',  whiteSpace: 'nowrap'}}>Choose one, multiple, or all exercises.</div>
                                        <div className="col-auto text-center">
                                            <RenderExerciseSelections />
                                        </div>
                                    </>
                                }

                                {/* WORKOUT WIZARD PROGRAMMING FIELDS */}
                                {
                                    ((BaseState.program === 'last' && LastWorkout.index > -1) || BaseState.program === 'new' || BaseState.program === 'recovery' ) &&
                                    <>

                                        {/* NUMBER OF WORKOUTS*/}
                                        <div className="row">
                                            <div className="col-6">
                                                <div className="text-center mb-2 mt-3" style={{fontSize: '75%',  whiteSpace: 'nowrap'}}># of Workouts to Generate</div>
                                                <div className="form-floating col-auto">
                                                    <input className="form-control ps-4" disabled={!has_measurements} id="number_of_workouts" value={BaseState.number_of_workouts} onChange={(event) => changeInputValue('number_of_workouts', event.target.value)} /> 
                                                    <label className="text-muted ms-2 h6" htmlFor="number_of_workouts">Workouts to Generate</label>
                                                </div>
                                            </div>
                                            <div className="col-6">
                                                <div className="text-center mb-2 mt-3" style={{fontSize: '75%',  whiteSpace: 'nowrap'}}># of Workouts per Increase (only for weight increases)</div>
                                                <div className="form-floating ">
                                                    <select 
                                                        className="form-select" 
                                                        disabled={!has_measurements}
                                                        id="workouts_per_increase"
                                                        onChange={(event) => changeInputValue('workouts_per_increase', event.target.value)}
                                                        placeholder="Workouts per Increase"
                                                        value={BaseState.workouts_per_increase}
                                                    >
                                                        <option value={1}>1</option>
                                                        <option value={2}>2</option>
                                                        <option value={3}>3</option>
                                                        <option value={4}>4</option>
                                                        <option value={5}>5</option>
                                                    </select> 
                                                    <label className="text-muted ms-2 h6" htmlFor="workouts_per_increase"># of Workouts per Increase</label>
                                                </div>
                                            </div>
                                            {/* <div className="col-6">
                                                <div className="text-center mb-2 mt-3" style={{fontSize: '75%',  whiteSpace: 'nowrap'}}># of Workouts per Increase</div>
                                                <div className="form-floating col-auto">
                                                    <input className="form-control ps-4" disabled={!has_measurements} id="workouts_per_increase" value={BaseState.workouts_per_increase} onChange={(event) => changeInputValue('workouts_per_increase', event.target.value)} /> 
                                                    <label className="text-muted ms-2 h6" htmlFor="workouts_per_increase">Workouts per Increase</label>
                                                </div>
                                            </div> */}
                                        </div>

                                        {/* DO NOT SHOW TORQUE INCREASES FOR RECOVERY */}
                                        {
                                            BaseState.program !== 'recovery' && BaseState.program !== 'created' &&
                                            <>
                                                {/* TORQUE INCREASE TYPE SELECTION */}
                                                <div className="col-12 text-center">
                                                    <div className="col-auto mt-3">
                                                        <div className="btn-group btn-group-sm" role="group">
                                                            <button className={`btn btn-outline-secondary w-auto ${(BaseState.torque_increase_type === 'exercise' && 'btn-secondary text-white border border-dark') || 'text-dark'}`} onClick={() => setBaseState({ ...BaseState, torque_increase_type: 'exercise', workout_generated: false })}>
                                                                Increase Work / Weight On Workout(s)
                                                            </button>
                                                            <button className={`btn btn-outline-secondary w-auto ${(BaseState.torque_increase_type === 'program' && 'btn-secondary text-white border border-dark') || 'text-dark'}`} onClick={() => setBaseState({ ...BaseState, torque_increase_type: 'program', workout_generated: false })}>
                                                                Increase Work / Weight On Entire Program
                                                            </button>
                                                        </div>                            
                                                    </div>
                                                </div>

                                                {/* TORQUE INCREASE PER WORKOUT */}
                                                <div className={`col-12 text-center mb-2 mt-3 ${(BaseState.torque_increase_type === 'program' && 'text-muted') || false}`} style={{fontSize: '75%',  whiteSpace: 'nowrap'}}>Choose each workout's desired increase per exercise</div>
                                                <div className="form-floating col-4">
                                                    <input className="form-control float" disabled={!has_measurements || BaseState.number_of_workouts == '' || BaseState.torque_increase_type === 'program'} id="increase_weight_by" value={BaseState.increase_weight_by} onChange={(event) => changeInputValue('increase_weight_by', event.target.value)} /> 
                                                    <label className="text-muted ms-2 h6" htmlFor="increase_weight_by">Weight (lbs)</label>
                                                </div>
                                                <div className="form-floating col-4">
                                                    <input className="form-control float" disabled={!has_measurements || BaseState.number_of_workouts == '' || BaseState.torque_increase_type === 'program'} id="increase_torque_by" value={BaseState.increase_torque_by} onChange={(event) => changeInputValue('increase_torque_by', event.target.value)} /> 
                                                    <label className="text-muted ms-2 h6" htmlFor="increase_torque_by">Work Performed (ft-lbs)</label>
                                                </div>
                                                <div className="form-floating col-4">
                                                    <input className="form-control float" disabled={!has_measurements || BaseState.number_of_workouts == '' || BaseState.torque_increase_type === 'program'} id="increase_torque_by_percentage" value={BaseState.increase_torque_by_percentage} onChange={(event) => changeInputValue('increase_torque_by_percentage', event.target.value)} /> 
                                                    <label className="text-muted ms-2 h6" htmlFor="increase_torque_by_percentage">Work Performed (%)</label>
                                                </div>

                                                {/* TORQUE INCREASE FOR WHOLE PROGRAM */}
                                                <div className={`col-12 text-center mb-2 mt-3 ${(BaseState.torque_increase_type === 'exercise' && 'text-muted') || false}`} style={{fontSize: '75%',  whiteSpace: 'nowrap'}}>Choose the entire program's desired increase per exercise</div>
                                                <div className="form-floating col-4">
                                                    <input className="form-control float" disabled={!has_measurements || BaseState.number_of_workouts == '' || BaseState.torque_increase_type === 'exercise'} id="increase_weight_by_program" value={BaseState.increase_weight_by_program} onChange={(event) => changeInputValue('increase_weight_by_program', event.target.value)} /> 
                                                    <label className="text-muted ms-2 h6" htmlFor="increase_weight_by_program">Weight (lbs)</label>
                                                </div>
                                                <div className="form-floating col-4">
                                                    <input className="form-control float" disabled={!has_measurements || BaseState.number_of_workouts == '' || BaseState.torque_increase_type === 'exercise'} id="increase_torque_by_program" value={BaseState.increase_torque_by_program} onChange={(event) => changeInputValue('increase_torque_by_program', event.target.value)} /> 
                                                    <label className="text-muted ms-2 h6" htmlFor="increase_torque_by_program">Work Performed (ft-lbs)</label>
                                                </div>
                                                <div className="form-floating col-4">
                                                    <input className="form-control float" disabled={!has_measurements || BaseState.number_of_workouts == '' || BaseState.torque_increase_type === 'exercise'} id="increase_torque_by_percentage_program" value={BaseState.increase_torque_by_percentage_program} onChange={(event) => changeInputValue('increase_torque_by_percentage_program', event.target.value)} /> 
                                                    <label className="text-muted ms-2 h6" htmlFor="increase_torque_by_percentage_program">Work Performed (%)</label>
                                                </div>
                                            </>
                                        }

                                        {/* CALCULATE */}
                                        <div className="col-12 text-center my-3">
                                            <button className="btn btn-sm fw-bolder text-primary border border-primary border-3" 
                                                // disabled={Reps === 0 || Weight === '' || Weight === 0 || Weight === 0.0 } 
                                                onClick={() => handleGenerateWorkouts()}>
                                                { !BaseState.workout_generated && <><FontAwesomeIcon icon="fa-wand-magic-sparkles" className="me-2" />Generate Workout Program</>}
                                                { BaseState.workout_generated && <><FontAwesomeIcon icon="fa-check" className="me-2" />Workout Program Generated</>}                                                
                                            </button>
                                        </div>
                                    </>
                                }

                                {/* EXISTING WORKOUT PROGRAMS */}
                                {
                                    BaseState.program === 'created' &&
                                    <>
                                        { WorkoutPrograms.length === 0 && <div className="col-12"><div className="alert alert-info mb-0 py-2 text-center" style={{fontSize: '75%'}}>There are no Workout Programs created yet</div></div>}
                                        { WorkoutPrograms.length > 0 && <RenderCreatedPrograms />}
                                    </>
                                }
                            </div>

                            {/* DISPLAY CALCULATED WORKOUTS */}
                            { BaseState.workouts_count > 0 && <RenderGeneratedWorkouts /> }
                            {/* <RenderGeneratedWorkouts /> */}
                        </>
                    }
                    {
                        !has_measurements &&
                        <div className="alert alert-info text-center">The Workout Wizard can only be used if this person has arm and forearm measurements recorded.</div>
                    }

                </div>

                {/* Footer - display calculated workouts */}
                {/* <div className="card-footer text-center border border-secondary border-top-0">
                    <table className="table table-striped table-hover">
                        <thead className="">
                            <tr className="row">
                                <th className="col">Exercise</th>
                                <th className="col">Reps</th>
                                <th className="col">Weight</th>
                                <th className="col">Set Torque (ft-lbs)</th>
                                <th className="col">Sets</th>
                                <th className="col">Total Torque (ft-lbs)</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                CalculatedWorkouts.map((CW) => {
                                    return (
                                        <tr className="row">
                                            <td className="col">
                                                {(CW.Arm === 'right' && 'R - ') || 'L - '}
                                                {CW.Exercise}
                                            </td>
                                            <td className="col">{CW.Reps}</td>
                                            <td className="col">{CW.Weight}</td>
                                            <td className="col">{CW.set_torque} ft-lbs</td>
                                            <td className="col">{CW.Sets}</td>
                                            <td className="col">{CW.total_torque} ft-lbs</td>
                                        </tr>
                                    )
                                })
                            }
                        </tbody>
                    </table>
                </div> */}
            </div>
        </div>
    )
}

